/* tslint:disable */
/* eslint-disable */
/**
 * engine
 *        👋 Welcome to the API documentation! This documentation provides a detailed overview of all the endpoints available in our API, along with their request and response formats, authentication requirements, and other important details.        Each endpoint is accompanied by a set of examples that demonstrate how to use it in various scenarios. These examples include sample requests and responses, as well as information on any error codes or messages that may be returned.        Note that some endpoints may require authentication or special permissions to access. If you\'re not sure how to authenticate with our API or what permissions are required for a particular endpoint, please refer to the authentication section of this documentation.        We hope you find this documentation helpful, and if you have any questions or feedback, please don\'t hesitate to contact us.
 *
 * The version of the OpenAPI document: 1.17.16
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
export const AccountCapabilitiesEnum = {
    Tags: 'tags',
    Variables: 'variables',
    VariablesDetection: 'variablesDetection',
    Documents: 'documents',
    Templates: 'templates',
    DownloadDoc: 'downloadDoc',
    DownloadPdf: 'downloadPdf',
    RepositorySearch: 'repositorySearch',
    RepositoryAdvancedSearch: 'repositoryAdvancedSearch',
    DocumentStatus: 'documentStatus',
    Versions: 'versions',
    IntegrationWebhook: 'integrationWebhook',
    IntegrationZapier: 'integrationZapier',
    IntegrationApi: 'integrationApi',
    IntegrationAi: 'integrationAi',
    AuthSaml: 'authSaml',
    FlowSharesApps: 'flowSharesApps',
    FlowSharePublic: 'flowSharePublic',
    FlowShareDirect: 'flowShareDirect',
    FlowSharePrivate: 'flowSharePrivate',
    FlowMultiple: 'flowMultiple',
    FlowBasicQuestions: 'flowBasicQuestions',
    FlowAdvancedQuestions: 'flowAdvancedQuestions',
    FlowRedirectUrl: 'flowRedirectUrl',
    FlowHideWatermark: 'flowHideWatermark',
    FlowCustomDesign: 'flowCustomDesign',
    FlowCustomDesignPalettes: 'flowCustomDesignPalettes',
    FlowSendCompletedDocument: 'flowSendCompletedDocument',
    FlowLogic: 'flowLogic',
    Flows: 'flows',
    Folders: 'folders',
    MassiveActions: 'massiveActions',
    DocumentsImport: 'documentsImport',
    ExportCsv: 'exportCsv',
    Branding: 'branding',
    BrandingEmails: 'brandingEmails',
    BrandingColors: 'brandingColors',
    NotificationCustomMessage: 'notificationCustomMessage',
    SupportHelpCenter: 'supportHelpCenter',
    SupportChat: 'supportChat',
    Contacts: 'contacts',
    Reminders: 'reminders',
    Marketplace: 'marketplace',
    MarketplacePublish: 'marketplacePublish',
    Categories: 'categories',
    Signatures: 'signatures',
    Parties: 'parties',
    Approvals: 'approvals',
    ApprovalMessages: 'approvalMessages',
    Activity: 'activity',
    Analytics: 'analytics',
    Teams: 'teams',
    Rules: 'rules',
    Workflows: 'workflows',
    SmartFields: 'smartFields',
    Attachments: 'attachments',
    Audit: 'audit',
    Notifications: 'notifications',
    Ocr: 'ocr',
};
export const AccountMyPermissionsEnum = {
    ViewAuditLog: 'ViewAuditLog',
    DeleteAccount: 'DeleteAccount',
    UpdateAccount: 'UpdateAccount',
    DeleteTags: 'DeleteTags',
    CreateTags: 'CreateTags',
    UpdateTags: 'UpdateTags',
    ViewTags: 'ViewTags',
    CreateCategories: 'CreateCategories',
    DeleteCategories: 'DeleteCategories',
    UpdateCategories: 'UpdateCategories',
    ViewCategories: 'ViewCategories',
    CreateAccountRoles: 'CreateAccountRoles',
    UpdateAccountRoles: 'UpdateAccountRoles',
    DeleteAccountRoles: 'DeleteAccountRoles',
    ViewAccountRoles: 'ViewAccountRoles',
    CreateDocumentRoles: 'CreateDocumentRoles',
    UpdateDocumentRoles: 'UpdateDocumentRoles',
    DeleteDocumentRoles: 'DeleteDocumentRoles',
    ViewDocumentRoles: 'ViewDocumentRoles',
    CreateAccountPolicies: 'CreateAccountPolicies',
    UpdateAccountPolicies: 'UpdateAccountPolicies',
    DeleteAccountPolicies: 'DeleteAccountPolicies',
    ViewAccountPolicies: 'ViewAccountPolicies',
    CreateTeams: 'CreateTeams',
    UpdateTeams: 'UpdateTeams',
    DeleteTeams: 'DeleteTeams',
    ViewTeams: 'ViewTeams',
    InviteUsers: 'InviteUsers',
    ViewUsers: 'ViewUsers',
    UpdateBilling: 'UpdateBilling',
    ViewBilling: 'ViewBilling',
    CreateSubscription: 'CreateSubscription',
    DeleteSubscription: 'DeleteSubscription',
    ViewSubscription: 'ViewSubscription',
    CreateWorkflows: 'CreateWorkflows',
    UpdateWorkflows: 'UpdateWorkflows',
    DeleteWorkflows: 'DeleteWorkflows',
    ViewWorkflows: 'ViewWorkflows',
    CreateRules: 'CreateRules',
    UpdateRules: 'UpdateRules',
    DeleteRules: 'DeleteRules',
    ViewRules: 'ViewRules',
    CreateAccountToken: 'CreateAccountToken',
    UpdateAccountToken: 'UpdateAccountToken',
    DeleteAccountToken: 'DeleteAccountToken',
    ViewAccountToken: 'ViewAccountToken',
    CreateDocuments: 'CreateDocuments',
    DeleteDocuments: 'DeleteDocuments',
    ArchiveDocuments: 'ArchiveDocuments',
    RestoreDocuments: 'RestoreDocuments',
    ViewDocuments: 'ViewDocuments',
    ViewAllDocuments: 'ViewAllDocuments',
    UpdateDocuments: 'UpdateDocuments',
    CreateTemplates: 'CreateTemplates',
    DeleteTemplates: 'DeleteTemplates',
    ViewTemplates: 'ViewTemplates',
    UpdateTemplates: 'UpdateTemplates',
    ConnectIntegrations: 'ConnectIntegrations',
    ViewIntegrations: 'ViewIntegrations',
    CreateSaml: 'CreateSaml',
    UpdateSaml: 'UpdateSaml',
    DeleteSaml: 'DeleteSaml',
    ViewSaml: 'ViewSaml',
    SubscribeWebhook: 'SubscribeWebhook',
    ViewWebhook: 'ViewWebhook',
    CreateContacts: 'CreateContacts',
    UpdateContacts: 'UpdateContacts',
    DeleteContacts: 'DeleteContacts',
    ViewContacts: 'ViewContacts',
    CreateFolders: 'CreateFolders',
    UpdateFolders: 'UpdateFolders',
    DeleteFolders: 'DeleteFolders',
    ViewFolders: 'ViewFolders',
    CreateMarketplaceItem: 'CreateMarketplaceItem',
    UpdateMarketplaceItem: 'UpdateMarketplaceItem',
    DeleteMarketplaceItem: 'DeleteMarketplaceItem',
    ViewAnalytics: 'ViewAnalytics',
};
export const CreateDocumentFromTemplateInputStatusEnum = {
    Initial: 'initial',
    Drafting: 'drafting',
    ToReview: 'toReview',
    Approved: 'approved',
    ToSign: 'toSign',
    Signing: 'signing',
    Signed: 'signed',
    PendingAction: 'pendingAction',
    Completed: 'completed',
    Active: 'active',
    ToExpire: 'toExpire',
    Expired: 'expired',
    Cancelled: 'cancelled',
};
export const UpdateDocumentStatusInputStatusEnum = {
    Initial: 'initial',
    Drafting: 'drafting',
    ToReview: 'toReview',
    Approved: 'approved',
    ToSign: 'toSign',
    Signing: 'signing',
    Signed: 'signed',
    PendingAction: 'pendingAction',
    Completed: 'completed',
    Active: 'active',
    ToExpire: 'toExpire',
    Expired: 'expired',
    Cancelled: 'cancelled',
};
export const UpdateOrCreateWebhookInputEventTypesEnum = {
    AdminCreated: 'AdminCreated',
    AdminUpdated: 'AdminUpdated',
    AdminDeleted: 'AdminDeleted',
    AdminEmailUpdated: 'AdminEmailUpdated',
    AdminPasswordUpdated: 'AdminPasswordUpdated',
    AdminAccessed: 'AdminAccessed',
    UserCreated: 'UserCreated',
    UserUpdated: 'UserUpdated',
    UserDeleted: 'UserDeleted',
    UserTosAccepted: 'UserTosAccepted',
    UserEmailUpdated: 'UserEmailUpdated',
    UserDisabled: 'UserDisabled',
    UserEnabled: 'UserEnabled',
    UserPasswordUpdated: 'UserPasswordUpdated',
    UserEmailVerified: 'UserEmailVerified',
    UserAccessed: 'UserAccessed',
    ProductCreated: 'ProductCreated',
    ProductUpdated: 'ProductUpdated',
    ProductDeleted: 'ProductDeleted',
    ProductCapabilitiesUpdated: 'ProductCapabilitiesUpdated',
    ProductQuotaCreated: 'ProductQuotaCreated',
    ProductQuotaUpdated: 'ProductQuotaUpdated',
    ProductQuotaDeleted: 'ProductQuotaDeleted',
    ProductQuotaDisabled: 'ProductQuotaDisabled',
    ProductQuotaEnabled: 'ProductQuotaEnabled',
    PaymentMethodCreated: 'PaymentMethodCreated',
    PaymentMethodUpdated: 'PaymentMethodUpdated',
    PaymentMethodDeleted: 'PaymentMethodDeleted',
    AddonCreated: 'AddonCreated',
    AddonUpdated: 'AddonUpdated',
    AddonDeleted: 'AddonDeleted',
    ContactCreated: 'ContactCreated',
    ContactUpdated: 'ContactUpdated',
    ContactDeleted: 'ContactDeleted',
    CurrencyCreated: 'CurrencyCreated',
    CurrencyUpdated: 'CurrencyUpdated',
    CurrencyDeleted: 'CurrencyDeleted',
    TaxRateCreated: 'TaxRateCreated',
    TaxRateUpdated: 'TaxRateUpdated',
    TaxRateDeleted: 'TaxRateDeleted',
    TaxRateDisabled: 'TaxRateDisabled',
    FormFlowCreated: 'FormFlowCreated',
    FormFlowUpdated: 'FormFlowUpdated',
    FormFlowSetDefault: 'FormFlowSetDefault',
    FormFlowDeleted: 'FormFlowDeleted',
    FormFlowCompleted: 'FormFlowCompleted',
    FormFlowShareCreated: 'FormFlowShareCreated',
    FormFlowShareUpdated: 'FormFlowShareUpdated',
    FormFlowShareDeleted: 'FormFlowShareDeleted',
    AccountCreated: 'AccountCreated',
    AccountDeleted: 'AccountDeleted',
    AccountUpdated: 'AccountUpdated',
    AccountTosAccepted: 'AccountTosAccepted',
    AccountEnabled: 'AccountEnabled',
    AccountDisabled: 'AccountDisabled',
    AccountPolicyCreated: 'AccountPolicyCreated',
    AccountPolicyUpdated: 'AccountPolicyUpdated',
    AccountPolicyDeleted: 'AccountPolicyDeleted',
    AccountPolicyAccessed: 'AccountPolicyAccessed',
    AccountRoleCreated: 'AccountRoleCreated',
    AccountRoleUpdated: 'AccountRoleUpdated',
    AccountRoleDeleted: 'AccountRoleDeleted',
    AccountTokenCreated: 'AccountTokenCreated',
    AccountTokenKeyUpdated: 'AccountTokenKeyUpdated',
    AccountTokenUpdated: 'AccountTokenUpdated',
    AccountTokenDeleted: 'AccountTokenDeleted',
    AccountTokenUsedAtUpdated: 'AccountTokenUsedAtUpdated',
    AccountSamlCreated: 'AccountSamlCreated',
    AccountSamlUpdated: 'AccountSamlUpdated',
    AccountSamlDeleted: 'AccountSamlDeleted',
    AccountIntegrationEnable: 'AccountIntegrationEnable',
    AccountIntegrationUpdated: 'AccountIntegrationUpdated',
    AccountIntegrationGenerateKey: 'AccountIntegrationGenerateKey',
    AccountIntegrationDisable: 'AccountIntegrationDisable',
    AccountIntegrationExecuted: 'AccountIntegrationExecuted',
    TemplateCreated: 'TemplateCreated',
    TemplateUpdated: 'TemplateUpdated',
    TemplateDeleted: 'TemplateDeleted',
    TemplatePublished: 'TemplatePublished',
    TemplateUnPublished: 'TemplateUnPublished',
    TemplateDestinationFolderUpdated: 'TemplateDestinationFolderUpdated',
    TagCreated: 'TagCreated',
    TagUpdated: 'TagUpdated',
    TagDeleted: 'TagDeleted',
    FolderCreated: 'FolderCreated',
    FolderUpdated: 'FolderUpdated',
    FolderDeleted: 'FolderDeleted',
    PartyCreated: 'PartyCreated',
    PartyUpdated: 'PartyUpdated',
    PartyDeleted: 'PartyDeleted',
    SecureNotificationCreated: 'SecureNotificationCreated',
    SecureNotificationUpdated: 'SecureNotificationUpdated',
    SecureNotificationDeleted: 'SecureNotificationDeleted',
    ReminderCreated: 'ReminderCreated',
    ReminderUpdated: 'ReminderUpdated',
    ReminderNotified: 'ReminderNotified',
    ReminderDeleted: 'ReminderDeleted',
    SignatureCreated: 'SignatureCreated',
    SignatureUpdated: 'SignatureUpdated',
    SignatureRequested: 'SignatureRequested',
    SignatureSigned: 'SignatureSigned',
    SignatureDeleted: 'SignatureDeleted',
    DocumentFullySigned: 'DocumentFullySigned',
    PlanCreated: 'PlanCreated',
    PlanUpdated: 'PlanUpdated',
    PlanDeleted: 'PlanDeleted',
    PlanDisabled: 'PlanDisabled',
    PlanEnabled: 'PlanEnabled',
    SubscriptionCreated: 'SubscriptionCreated',
    SubscriptionUpdated: 'SubscriptionUpdated',
    SubscriptionDeleted: 'SubscriptionDeleted',
    SubscriptionCancelled: 'SubscriptionCancelled',
    SubscriptionCapabilitiesUpdated: 'SubscriptionCapabilitiesUpdated',
    StripeChargeFailed: 'StripeChargeFailed',
    StripeChargeSucceeded: 'StripeChargeSucceeded',
    StripeCustomerCreated: 'StripeCustomerCreated',
    StripeCustomerDeleted: 'StripeCustomerDeleted',
    StripeCustomerDiscountCreated: 'StripeCustomerDiscountCreated',
    StripeCustomerDiscountDeleted: 'StripeCustomerDiscountDeleted',
    StripeCustomerDiscountUpdated: 'StripeCustomerDiscountUpdated',
    StripeCustomerSourceCreated: 'StripeCustomerSourceCreated',
    StripeCustomerSourceUpdated: 'StripeCustomerSourceUpdated',
    StripeCustomerSubscriptionCreated: 'StripeCustomerSubscriptionCreated',
    StripeCustomerSubscriptionDeleted: 'StripeCustomerSubscriptionDeleted',
    StripeCustomerSubscriptionPendingUpdateApplied: 'StripeCustomerSubscriptionPendingUpdateApplied',
    StripeCustomerSubscriptionPendingUpdateExpired: 'StripeCustomerSubscriptionPendingUpdateExpired',
    StripeCustomerSubscriptionTrialWillEnd: 'StripeCustomerSubscriptionTrialWillEnd',
    StripeCustomerSubscriptionUpdated: 'StripeCustomerSubscriptionUpdated',
    StripeCustomerUpdated: 'StripeCustomerUpdated',
    StripeInvoiceCreated: 'StripeInvoiceCreated',
    StripeInvoiceFinalizationFailed: 'StripeInvoiceFinalizationFailed',
    StripeInvoiceFinalized: 'StripeInvoiceFinalized',
    StripeInvoiceItemCreated: 'StripeInvoiceItemCreated',
    StripeInvoiceItemDeleted: 'StripeInvoiceItemDeleted',
    StripeInvoiceItemUpdated: 'StripeInvoiceItemUpdated',
    StripeInvoicePaid: 'StripeInvoicePaid',
    StripeInvoicePaymentFailed: 'StripeInvoicePaymentFailed',
    StripeInvoicePaymentSucceeded: 'StripeInvoicePaymentSucceeded',
    StripeInvoiceSent: 'StripeInvoiceSent',
    StripeInvoiceUpcoming: 'StripeInvoiceUpcoming',
    StripeInvoiceUpdated: 'StripeInvoiceUpdated',
    StripeIssuingAuthorizationRequest: 'StripeIssuingAuthorizationRequest',
    StripeIssuingAuthorizationUpdated: 'StripeIssuingAuthorizationUpdated',
    StripeIssuingCardCreated: 'StripeIssuingCardCreated',
    StripeIssuingCardHolderCreated: 'StripeIssuingCardHolderCreated',
    StripeIssuingCardHolderUpdated: 'StripeIssuingCardHolderUpdated',
    StripeIssuingCardUpdated: 'StripeIssuingCardUpdated',
    StripePaymentIntentAmountCapturableUpdated: 'StripePaymentIntentAmountCapturableUpdated',
    StripePaymentIntentCanceled: 'StripePaymentIntentCanceled',
    StripePaymentIntentCreated: 'StripePaymentIntentCreated',
    StripePaymentIntentPaymentFailed: 'StripePaymentIntentPaymentFailed',
    StripePaymentIntentSucceeded: 'StripePaymentIntentSucceeded',
    StripePaymentMethodAttached: 'StripePaymentMethodAttached',
    StripePaymentMethodDetached: 'StripePaymentMethodDetached',
    StripePaymentMethodUpdated: 'StripePaymentMethodUpdated',
    StripePlanCreated: 'StripePlanCreated',
    StripePlanDeleted: 'StripePlanDeleted',
    StripePlanUpdated: 'StripePlanUpdated',
    StripePriceCreated: 'StripePriceCreated',
    StripePriceDeleted: 'StripePriceDeleted',
    StripePriceUpdated: 'StripePriceUpdated',
    StripeProductCreated: 'StripeProductCreated',
    StripeProductDeleted: 'StripeProductDeleted',
    StripeProductUpdated: 'StripeProductUpdated',
    StripePromotionCodeCreated: 'StripePromotionCodeCreated',
    StripePromotionCodeUpdated: 'StripePromotionCodeUpdated',
    StripeSetupIntentCreated: 'StripeSetupIntentCreated',
    StripeSetupIntentFailed: 'StripeSetupIntentFailed',
    StripeSetupIntentRequiresAction: 'StripeSetupIntentRequiresAction',
    StripeSetupIntentSucceeded: 'StripeSetupIntentSucceeded',
    StripeTaxRateCreated: 'StripeTaxRateCreated',
    StripeTaxRateDeleted: 'StripeTaxRateDeleted',
    StripeTaxRateUpdated: 'StripeTaxRateUpdated',
    StripeCustomerTaxIdCreated: 'StripeCustomerTaxIdCreated',
    StripeCustomerTaxIdDeleted: 'StripeCustomerTaxIdDeleted',
    StripeCustomerTaxIdUpdated: 'StripeCustomerTaxIdUpdated',
    CategoryCreated: 'CategoryCreated',
    CategoryUpdated: 'CategoryUpdated',
    CategoryDeleted: 'CategoryDeleted',
    DocumentFullyApproved: 'DocumentFullyApproved',
    DocumentFullyRejected: 'DocumentFullyRejected',
    ApprovalCreated: 'ApprovalCreated',
    ApprovalUpdated: 'ApprovalUpdated',
    ApprovalDeleted: 'ApprovalDeleted',
    ApprovalRequested: 'ApprovalRequested',
    ApprovalApproved: 'ApprovalApproved',
    ApprovalRejected: 'ApprovalRejected',
    ApprovalMessageCreated: 'ApprovalMessageCreated',
    ApprovalMessageUpdated: 'ApprovalMessageUpdated',
    ApprovalMessageDeleted: 'ApprovalMessageDeleted',
    DocumentCreated: 'DocumentCreated',
    DocumentUpdated: 'DocumentUpdated',
    DocumentStatusUpdated: 'DocumentStatusUpdated',
    DocumentDeleted: 'DocumentDeleted',
    DocumentCancelled: 'DocumentCancelled',
    DocumentArchived: 'DocumentArchived',
    DocumentRestored: 'DocumentRestored',
    DocumentActivated: 'DocumentActivated',
    DocumentToExpired: 'DocumentToExpired',
    DocumentExpired: 'DocumentExpired',
    DocumentDestinationFolderUpdated: 'DocumentDestinationFolderUpdated',
    DocumentPolicyCreated: 'DocumentPolicyCreated',
    DocumentPolicyUpdated: 'DocumentPolicyUpdated',
    DocumentPolicyDeleted: 'DocumentPolicyDeleted',
    DocumentPolicyAccessed: 'DocumentPolicyAccessed',
    DocumentRoleCreated: 'DocumentRoleCreated',
    DocumentRoleUpdated: 'DocumentRoleUpdated',
    DocumentRoleDeleted: 'DocumentRoleDeleted',
    DocumentContentCreated: 'DocumentContentCreated',
    DocumentContentStatusUpdated: 'DocumentContentStatusUpdated',
    DocumentContentUpdated: 'DocumentContentUpdated',
    DocumentContentDeleted: 'DocumentContentDeleted',
    DocumentContentReadOnly: 'DocumentContentReadOnly',
    ShareCreated: 'ShareCreated',
    ShareUpdated: 'ShareUpdated',
    ShareDeleted: 'ShareDeleted',
    IntegrationCreated: 'IntegrationCreated',
    IntegrationUpdated: 'IntegrationUpdated',
    IntegrationDeleted: 'IntegrationDeleted',
    WebhookCreated: 'WebhookCreated',
    WebhookUpdated: 'WebhookUpdated',
    WebhookDeleted: 'WebhookDeleted',
    MarketplaceItemCreated: 'MarketplaceItemCreated',
    MarketplaceItemUpdated: 'MarketplaceItemUpdated',
    MarketplaceItemApproveUpdated: 'MarketplaceItemApproveUpdated',
    MarketplaceItemDeleted: 'MarketplaceItemDeleted',
    RuleCreated: 'RuleCreated',
    RuleUpdated: 'RuleUpdated',
    RuleDeleted: 'RuleDeleted',
    RuleExecutionCreated: 'RuleExecutionCreated',
    RuleExecutionDeleted: 'RuleExecutionDeleted',
};
/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves an Account object.
         * @summary Retrieve your account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccount: async (options = {}) => {
            const localVarPath = `/v1/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves an Account object.
         * @summary Retrieve your account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAccount(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountApiFp(configuration);
    return {
        /**
         * Retrieves an Account object.
         * @summary Retrieve your account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccount(options) {
            return localVarFp
                .retrieveAccount(options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * Retrieves an Account object.
     * @summary Retrieve your account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    retrieveAccount(options) {
        return AccountApiFp(this.configuration)
            .retrieveAccount(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve your account
         * @summary Retrieve your account
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccount: async (bounselAccount, options = {}) => {
            const localVarPath = `/vapp/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            if (bounselAccount != null) {
                localVarHeaderParameter['bounsel-account'] = String(bounselAccount);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve your account
         * @summary Retrieve your account
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAccount(bounselAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAccount(bounselAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountsApiFp(configuration);
    return {
        /**
         * Retrieve your account
         * @summary Retrieve your account
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccount(bounselAccount, options) {
            return localVarFp
                .retrieveAccount(bounselAccount, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     * Retrieve your account
     * @summary Retrieve your account
     * @param {string} [bounselAccount] Active account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    retrieveAccount(bounselAccount, options) {
        return AccountsApiFp(this.configuration)
            .retrieveAccount(bounselAccount, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuditApi - axios parameter creator
 * @export
 */
export const AuditApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns the last event object of a type.
         * @summary Retrieve last event object
         * @param {Array<'AdminCreated' | 'AdminUpdated' | 'AdminDeleted' | 'AdminEmailUpdated' | 'AdminPasswordUpdated' | 'AdminAccessed' | 'UserCreated' | 'UserUpdated' | 'UserDeleted' | 'UserTosAccepted' | 'UserEmailUpdated' | 'UserDisabled' | 'UserEnabled' | 'UserPasswordUpdated' | 'UserEmailVerified' | 'UserAccessed' | 'ProductCreated' | 'ProductUpdated' | 'ProductDeleted' | 'ProductCapabilitiesUpdated' | 'ProductQuotaCreated' | 'ProductQuotaUpdated' | 'ProductQuotaDeleted' | 'ProductQuotaDisabled' | 'ProductQuotaEnabled' | 'PaymentMethodCreated' | 'PaymentMethodUpdated' | 'PaymentMethodDeleted' | 'AddonCreated' | 'AddonUpdated' | 'AddonDeleted' | 'ContactCreated' | 'ContactUpdated' | 'ContactDeleted' | 'CurrencyCreated' | 'CurrencyUpdated' | 'CurrencyDeleted' | 'TaxRateCreated' | 'TaxRateUpdated' | 'TaxRateDeleted' | 'TaxRateDisabled' | 'FormFlowCreated' | 'FormFlowUpdated' | 'FormFlowSetDefault' | 'FormFlowDeleted' | 'FormFlowCompleted' | 'FormFlowShareCreated' | 'FormFlowShareUpdated' | 'FormFlowShareDeleted' | 'AccountCreated' | 'AccountDeleted' | 'AccountUpdated' | 'AccountTosAccepted' | 'AccountEnabled' | 'AccountDisabled' | 'AccountPolicyCreated' | 'AccountPolicyUpdated' | 'AccountPolicyDeleted' | 'AccountPolicyAccessed' | 'AccountRoleCreated' | 'AccountRoleUpdated' | 'AccountRoleDeleted' | 'AccountTokenCreated' | 'AccountTokenKeyUpdated' | 'AccountTokenUpdated' | 'AccountTokenDeleted' | 'AccountTokenUsedAtUpdated' | 'AccountSamlCreated' | 'AccountSamlUpdated' | 'AccountSamlDeleted' | 'AccountIntegrationEnable' | 'AccountIntegrationUpdated' | 'AccountIntegrationGenerateKey' | 'AccountIntegrationDisable' | 'AccountIntegrationExecuted' | 'TemplateCreated' | 'TemplateUpdated' | 'TemplateDeleted' | 'TemplatePublished' | 'TemplateUnPublished' | 'TemplateDestinationFolderUpdated' | 'TagCreated' | 'TagUpdated' | 'TagDeleted' | 'FolderCreated' | 'FolderUpdated' | 'FolderDeleted' | 'PartyCreated' | 'PartyUpdated' | 'PartyDeleted' | 'SecureNotificationCreated' | 'SecureNotificationUpdated' | 'SecureNotificationDeleted' | 'ReminderCreated' | 'ReminderUpdated' | 'ReminderNotified' | 'ReminderDeleted' | 'SignatureCreated' | 'SignatureUpdated' | 'SignatureRequested' | 'SignatureSigned' | 'SignatureDeleted' | 'DocumentFullySigned' | 'PlanCreated' | 'PlanUpdated' | 'PlanDeleted' | 'PlanDisabled' | 'PlanEnabled' | 'SubscriptionCreated' | 'SubscriptionUpdated' | 'SubscriptionDeleted' | 'SubscriptionCancelled' | 'SubscriptionCapabilitiesUpdated' | 'StripeChargeFailed' | 'StripeChargeSucceeded' | 'StripeCustomerCreated' | 'StripeCustomerDeleted' | 'StripeCustomerDiscountCreated' | 'StripeCustomerDiscountDeleted' | 'StripeCustomerDiscountUpdated' | 'StripeCustomerSourceCreated' | 'StripeCustomerSourceUpdated' | 'StripeCustomerSubscriptionCreated' | 'StripeCustomerSubscriptionDeleted' | 'StripeCustomerSubscriptionPendingUpdateApplied' | 'StripeCustomerSubscriptionPendingUpdateExpired' | 'StripeCustomerSubscriptionTrialWillEnd' | 'StripeCustomerSubscriptionUpdated' | 'StripeCustomerUpdated' | 'StripeInvoiceCreated' | 'StripeInvoiceFinalizationFailed' | 'StripeInvoiceFinalized' | 'StripeInvoiceItemCreated' | 'StripeInvoiceItemDeleted' | 'StripeInvoiceItemUpdated' | 'StripeInvoicePaid' | 'StripeInvoicePaymentFailed' | 'StripeInvoicePaymentSucceeded' | 'StripeInvoiceSent' | 'StripeInvoiceUpcoming' | 'StripeInvoiceUpdated' | 'StripeIssuingAuthorizationRequest' | 'StripeIssuingAuthorizationUpdated' | 'StripeIssuingCardCreated' | 'StripeIssuingCardHolderCreated' | 'StripeIssuingCardHolderUpdated' | 'StripeIssuingCardUpdated' | 'StripePaymentIntentAmountCapturableUpdated' | 'StripePaymentIntentCanceled' | 'StripePaymentIntentCreated' | 'StripePaymentIntentPaymentFailed' | 'StripePaymentIntentSucceeded' | 'StripePaymentMethodAttached' | 'StripePaymentMethodDetached' | 'StripePaymentMethodUpdated' | 'StripePlanCreated' | 'StripePlanDeleted' | 'StripePlanUpdated' | 'StripePriceCreated' | 'StripePriceDeleted' | 'StripePriceUpdated' | 'StripeProductCreated' | 'StripeProductDeleted' | 'StripeProductUpdated' | 'StripePromotionCodeCreated' | 'StripePromotionCodeUpdated' | 'StripeSetupIntentCreated' | 'StripeSetupIntentFailed' | 'StripeSetupIntentRequiresAction' | 'StripeSetupIntentSucceeded' | 'StripeTaxRateCreated' | 'StripeTaxRateDeleted' | 'StripeTaxRateUpdated' | 'StripeCustomerTaxIdCreated' | 'StripeCustomerTaxIdDeleted' | 'StripeCustomerTaxIdUpdated' | 'CategoryCreated' | 'CategoryUpdated' | 'CategoryDeleted' | 'DocumentFullyApproved' | 'DocumentFullyRejected' | 'ApprovalCreated' | 'ApprovalUpdated' | 'ApprovalDeleted' | 'ApprovalRequested' | 'ApprovalApproved' | 'ApprovalRejected' | 'ApprovalMessageCreated' | 'ApprovalMessageUpdated' | 'ApprovalMessageDeleted' | 'DocumentCreated' | 'DocumentUpdated' | 'DocumentStatusUpdated' | 'DocumentDeleted' | 'DocumentCancelled' | 'DocumentArchived' | 'DocumentRestored' | 'DocumentActivated' | 'DocumentToExpired' | 'DocumentExpired' | 'DocumentDestinationFolderUpdated' | 'DocumentPolicyCreated' | 'DocumentPolicyUpdated' | 'DocumentPolicyDeleted' | 'DocumentPolicyAccessed' | 'DocumentRoleCreated' | 'DocumentRoleUpdated' | 'DocumentRoleDeleted' | 'DocumentContentCreated' | 'DocumentContentStatusUpdated' | 'DocumentContentUpdated' | 'DocumentContentDeleted' | 'DocumentContentReadOnly' | 'ShareCreated' | 'ShareUpdated' | 'ShareDeleted' | 'IntegrationCreated' | 'IntegrationUpdated' | 'IntegrationDeleted' | 'WebhookCreated' | 'WebhookUpdated' | 'WebhookDeleted' | 'MarketplaceItemCreated' | 'MarketplaceItemUpdated' | 'MarketplaceItemApproveUpdated' | 'MarketplaceItemDeleted' | 'RuleCreated' | 'RuleUpdated' | 'RuleDeleted' | 'RuleExecutionCreated' | 'RuleExecutionDeleted'>} eventTypes The ID of the __Template__ from which we was generate this flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveObjectEvent: async (eventTypes, options = {}) => {
            // verify required parameter 'eventTypes' is not null or undefined
            assertParamExists('retrieveObjectEvent', 'eventTypes', eventTypes);
            const localVarPath = `/v1/audits/lastEvent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (eventTypes) {
                localVarQueryParameter['eventTypes'] = eventTypes;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuditApi - functional programming interface
 * @export
 */
export const AuditApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuditApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns the last event object of a type.
         * @summary Retrieve last event object
         * @param {Array<'AdminCreated' | 'AdminUpdated' | 'AdminDeleted' | 'AdminEmailUpdated' | 'AdminPasswordUpdated' | 'AdminAccessed' | 'UserCreated' | 'UserUpdated' | 'UserDeleted' | 'UserTosAccepted' | 'UserEmailUpdated' | 'UserDisabled' | 'UserEnabled' | 'UserPasswordUpdated' | 'UserEmailVerified' | 'UserAccessed' | 'ProductCreated' | 'ProductUpdated' | 'ProductDeleted' | 'ProductCapabilitiesUpdated' | 'ProductQuotaCreated' | 'ProductQuotaUpdated' | 'ProductQuotaDeleted' | 'ProductQuotaDisabled' | 'ProductQuotaEnabled' | 'PaymentMethodCreated' | 'PaymentMethodUpdated' | 'PaymentMethodDeleted' | 'AddonCreated' | 'AddonUpdated' | 'AddonDeleted' | 'ContactCreated' | 'ContactUpdated' | 'ContactDeleted' | 'CurrencyCreated' | 'CurrencyUpdated' | 'CurrencyDeleted' | 'TaxRateCreated' | 'TaxRateUpdated' | 'TaxRateDeleted' | 'TaxRateDisabled' | 'FormFlowCreated' | 'FormFlowUpdated' | 'FormFlowSetDefault' | 'FormFlowDeleted' | 'FormFlowCompleted' | 'FormFlowShareCreated' | 'FormFlowShareUpdated' | 'FormFlowShareDeleted' | 'AccountCreated' | 'AccountDeleted' | 'AccountUpdated' | 'AccountTosAccepted' | 'AccountEnabled' | 'AccountDisabled' | 'AccountPolicyCreated' | 'AccountPolicyUpdated' | 'AccountPolicyDeleted' | 'AccountPolicyAccessed' | 'AccountRoleCreated' | 'AccountRoleUpdated' | 'AccountRoleDeleted' | 'AccountTokenCreated' | 'AccountTokenKeyUpdated' | 'AccountTokenUpdated' | 'AccountTokenDeleted' | 'AccountTokenUsedAtUpdated' | 'AccountSamlCreated' | 'AccountSamlUpdated' | 'AccountSamlDeleted' | 'AccountIntegrationEnable' | 'AccountIntegrationUpdated' | 'AccountIntegrationGenerateKey' | 'AccountIntegrationDisable' | 'AccountIntegrationExecuted' | 'TemplateCreated' | 'TemplateUpdated' | 'TemplateDeleted' | 'TemplatePublished' | 'TemplateUnPublished' | 'TemplateDestinationFolderUpdated' | 'TagCreated' | 'TagUpdated' | 'TagDeleted' | 'FolderCreated' | 'FolderUpdated' | 'FolderDeleted' | 'PartyCreated' | 'PartyUpdated' | 'PartyDeleted' | 'SecureNotificationCreated' | 'SecureNotificationUpdated' | 'SecureNotificationDeleted' | 'ReminderCreated' | 'ReminderUpdated' | 'ReminderNotified' | 'ReminderDeleted' | 'SignatureCreated' | 'SignatureUpdated' | 'SignatureRequested' | 'SignatureSigned' | 'SignatureDeleted' | 'DocumentFullySigned' | 'PlanCreated' | 'PlanUpdated' | 'PlanDeleted' | 'PlanDisabled' | 'PlanEnabled' | 'SubscriptionCreated' | 'SubscriptionUpdated' | 'SubscriptionDeleted' | 'SubscriptionCancelled' | 'SubscriptionCapabilitiesUpdated' | 'StripeChargeFailed' | 'StripeChargeSucceeded' | 'StripeCustomerCreated' | 'StripeCustomerDeleted' | 'StripeCustomerDiscountCreated' | 'StripeCustomerDiscountDeleted' | 'StripeCustomerDiscountUpdated' | 'StripeCustomerSourceCreated' | 'StripeCustomerSourceUpdated' | 'StripeCustomerSubscriptionCreated' | 'StripeCustomerSubscriptionDeleted' | 'StripeCustomerSubscriptionPendingUpdateApplied' | 'StripeCustomerSubscriptionPendingUpdateExpired' | 'StripeCustomerSubscriptionTrialWillEnd' | 'StripeCustomerSubscriptionUpdated' | 'StripeCustomerUpdated' | 'StripeInvoiceCreated' | 'StripeInvoiceFinalizationFailed' | 'StripeInvoiceFinalized' | 'StripeInvoiceItemCreated' | 'StripeInvoiceItemDeleted' | 'StripeInvoiceItemUpdated' | 'StripeInvoicePaid' | 'StripeInvoicePaymentFailed' | 'StripeInvoicePaymentSucceeded' | 'StripeInvoiceSent' | 'StripeInvoiceUpcoming' | 'StripeInvoiceUpdated' | 'StripeIssuingAuthorizationRequest' | 'StripeIssuingAuthorizationUpdated' | 'StripeIssuingCardCreated' | 'StripeIssuingCardHolderCreated' | 'StripeIssuingCardHolderUpdated' | 'StripeIssuingCardUpdated' | 'StripePaymentIntentAmountCapturableUpdated' | 'StripePaymentIntentCanceled' | 'StripePaymentIntentCreated' | 'StripePaymentIntentPaymentFailed' | 'StripePaymentIntentSucceeded' | 'StripePaymentMethodAttached' | 'StripePaymentMethodDetached' | 'StripePaymentMethodUpdated' | 'StripePlanCreated' | 'StripePlanDeleted' | 'StripePlanUpdated' | 'StripePriceCreated' | 'StripePriceDeleted' | 'StripePriceUpdated' | 'StripeProductCreated' | 'StripeProductDeleted' | 'StripeProductUpdated' | 'StripePromotionCodeCreated' | 'StripePromotionCodeUpdated' | 'StripeSetupIntentCreated' | 'StripeSetupIntentFailed' | 'StripeSetupIntentRequiresAction' | 'StripeSetupIntentSucceeded' | 'StripeTaxRateCreated' | 'StripeTaxRateDeleted' | 'StripeTaxRateUpdated' | 'StripeCustomerTaxIdCreated' | 'StripeCustomerTaxIdDeleted' | 'StripeCustomerTaxIdUpdated' | 'CategoryCreated' | 'CategoryUpdated' | 'CategoryDeleted' | 'DocumentFullyApproved' | 'DocumentFullyRejected' | 'ApprovalCreated' | 'ApprovalUpdated' | 'ApprovalDeleted' | 'ApprovalRequested' | 'ApprovalApproved' | 'ApprovalRejected' | 'ApprovalMessageCreated' | 'ApprovalMessageUpdated' | 'ApprovalMessageDeleted' | 'DocumentCreated' | 'DocumentUpdated' | 'DocumentStatusUpdated' | 'DocumentDeleted' | 'DocumentCancelled' | 'DocumentArchived' | 'DocumentRestored' | 'DocumentActivated' | 'DocumentToExpired' | 'DocumentExpired' | 'DocumentDestinationFolderUpdated' | 'DocumentPolicyCreated' | 'DocumentPolicyUpdated' | 'DocumentPolicyDeleted' | 'DocumentPolicyAccessed' | 'DocumentRoleCreated' | 'DocumentRoleUpdated' | 'DocumentRoleDeleted' | 'DocumentContentCreated' | 'DocumentContentStatusUpdated' | 'DocumentContentUpdated' | 'DocumentContentDeleted' | 'DocumentContentReadOnly' | 'ShareCreated' | 'ShareUpdated' | 'ShareDeleted' | 'IntegrationCreated' | 'IntegrationUpdated' | 'IntegrationDeleted' | 'WebhookCreated' | 'WebhookUpdated' | 'WebhookDeleted' | 'MarketplaceItemCreated' | 'MarketplaceItemUpdated' | 'MarketplaceItemApproveUpdated' | 'MarketplaceItemDeleted' | 'RuleCreated' | 'RuleUpdated' | 'RuleDeleted' | 'RuleExecutionCreated' | 'RuleExecutionDeleted'>} eventTypes The ID of the __Template__ from which we was generate this flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveObjectEvent(eventTypes, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveObjectEvent(eventTypes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AuditApi - factory interface
 * @export
 */
export const AuditApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuditApiFp(configuration);
    return {
        /**
         * Returns the last event object of a type.
         * @summary Retrieve last event object
         * @param {Array<'AdminCreated' | 'AdminUpdated' | 'AdminDeleted' | 'AdminEmailUpdated' | 'AdminPasswordUpdated' | 'AdminAccessed' | 'UserCreated' | 'UserUpdated' | 'UserDeleted' | 'UserTosAccepted' | 'UserEmailUpdated' | 'UserDisabled' | 'UserEnabled' | 'UserPasswordUpdated' | 'UserEmailVerified' | 'UserAccessed' | 'ProductCreated' | 'ProductUpdated' | 'ProductDeleted' | 'ProductCapabilitiesUpdated' | 'ProductQuotaCreated' | 'ProductQuotaUpdated' | 'ProductQuotaDeleted' | 'ProductQuotaDisabled' | 'ProductQuotaEnabled' | 'PaymentMethodCreated' | 'PaymentMethodUpdated' | 'PaymentMethodDeleted' | 'AddonCreated' | 'AddonUpdated' | 'AddonDeleted' | 'ContactCreated' | 'ContactUpdated' | 'ContactDeleted' | 'CurrencyCreated' | 'CurrencyUpdated' | 'CurrencyDeleted' | 'TaxRateCreated' | 'TaxRateUpdated' | 'TaxRateDeleted' | 'TaxRateDisabled' | 'FormFlowCreated' | 'FormFlowUpdated' | 'FormFlowSetDefault' | 'FormFlowDeleted' | 'FormFlowCompleted' | 'FormFlowShareCreated' | 'FormFlowShareUpdated' | 'FormFlowShareDeleted' | 'AccountCreated' | 'AccountDeleted' | 'AccountUpdated' | 'AccountTosAccepted' | 'AccountEnabled' | 'AccountDisabled' | 'AccountPolicyCreated' | 'AccountPolicyUpdated' | 'AccountPolicyDeleted' | 'AccountPolicyAccessed' | 'AccountRoleCreated' | 'AccountRoleUpdated' | 'AccountRoleDeleted' | 'AccountTokenCreated' | 'AccountTokenKeyUpdated' | 'AccountTokenUpdated' | 'AccountTokenDeleted' | 'AccountTokenUsedAtUpdated' | 'AccountSamlCreated' | 'AccountSamlUpdated' | 'AccountSamlDeleted' | 'AccountIntegrationEnable' | 'AccountIntegrationUpdated' | 'AccountIntegrationGenerateKey' | 'AccountIntegrationDisable' | 'AccountIntegrationExecuted' | 'TemplateCreated' | 'TemplateUpdated' | 'TemplateDeleted' | 'TemplatePublished' | 'TemplateUnPublished' | 'TemplateDestinationFolderUpdated' | 'TagCreated' | 'TagUpdated' | 'TagDeleted' | 'FolderCreated' | 'FolderUpdated' | 'FolderDeleted' | 'PartyCreated' | 'PartyUpdated' | 'PartyDeleted' | 'SecureNotificationCreated' | 'SecureNotificationUpdated' | 'SecureNotificationDeleted' | 'ReminderCreated' | 'ReminderUpdated' | 'ReminderNotified' | 'ReminderDeleted' | 'SignatureCreated' | 'SignatureUpdated' | 'SignatureRequested' | 'SignatureSigned' | 'SignatureDeleted' | 'DocumentFullySigned' | 'PlanCreated' | 'PlanUpdated' | 'PlanDeleted' | 'PlanDisabled' | 'PlanEnabled' | 'SubscriptionCreated' | 'SubscriptionUpdated' | 'SubscriptionDeleted' | 'SubscriptionCancelled' | 'SubscriptionCapabilitiesUpdated' | 'StripeChargeFailed' | 'StripeChargeSucceeded' | 'StripeCustomerCreated' | 'StripeCustomerDeleted' | 'StripeCustomerDiscountCreated' | 'StripeCustomerDiscountDeleted' | 'StripeCustomerDiscountUpdated' | 'StripeCustomerSourceCreated' | 'StripeCustomerSourceUpdated' | 'StripeCustomerSubscriptionCreated' | 'StripeCustomerSubscriptionDeleted' | 'StripeCustomerSubscriptionPendingUpdateApplied' | 'StripeCustomerSubscriptionPendingUpdateExpired' | 'StripeCustomerSubscriptionTrialWillEnd' | 'StripeCustomerSubscriptionUpdated' | 'StripeCustomerUpdated' | 'StripeInvoiceCreated' | 'StripeInvoiceFinalizationFailed' | 'StripeInvoiceFinalized' | 'StripeInvoiceItemCreated' | 'StripeInvoiceItemDeleted' | 'StripeInvoiceItemUpdated' | 'StripeInvoicePaid' | 'StripeInvoicePaymentFailed' | 'StripeInvoicePaymentSucceeded' | 'StripeInvoiceSent' | 'StripeInvoiceUpcoming' | 'StripeInvoiceUpdated' | 'StripeIssuingAuthorizationRequest' | 'StripeIssuingAuthorizationUpdated' | 'StripeIssuingCardCreated' | 'StripeIssuingCardHolderCreated' | 'StripeIssuingCardHolderUpdated' | 'StripeIssuingCardUpdated' | 'StripePaymentIntentAmountCapturableUpdated' | 'StripePaymentIntentCanceled' | 'StripePaymentIntentCreated' | 'StripePaymentIntentPaymentFailed' | 'StripePaymentIntentSucceeded' | 'StripePaymentMethodAttached' | 'StripePaymentMethodDetached' | 'StripePaymentMethodUpdated' | 'StripePlanCreated' | 'StripePlanDeleted' | 'StripePlanUpdated' | 'StripePriceCreated' | 'StripePriceDeleted' | 'StripePriceUpdated' | 'StripeProductCreated' | 'StripeProductDeleted' | 'StripeProductUpdated' | 'StripePromotionCodeCreated' | 'StripePromotionCodeUpdated' | 'StripeSetupIntentCreated' | 'StripeSetupIntentFailed' | 'StripeSetupIntentRequiresAction' | 'StripeSetupIntentSucceeded' | 'StripeTaxRateCreated' | 'StripeTaxRateDeleted' | 'StripeTaxRateUpdated' | 'StripeCustomerTaxIdCreated' | 'StripeCustomerTaxIdDeleted' | 'StripeCustomerTaxIdUpdated' | 'CategoryCreated' | 'CategoryUpdated' | 'CategoryDeleted' | 'DocumentFullyApproved' | 'DocumentFullyRejected' | 'ApprovalCreated' | 'ApprovalUpdated' | 'ApprovalDeleted' | 'ApprovalRequested' | 'ApprovalApproved' | 'ApprovalRejected' | 'ApprovalMessageCreated' | 'ApprovalMessageUpdated' | 'ApprovalMessageDeleted' | 'DocumentCreated' | 'DocumentUpdated' | 'DocumentStatusUpdated' | 'DocumentDeleted' | 'DocumentCancelled' | 'DocumentArchived' | 'DocumentRestored' | 'DocumentActivated' | 'DocumentToExpired' | 'DocumentExpired' | 'DocumentDestinationFolderUpdated' | 'DocumentPolicyCreated' | 'DocumentPolicyUpdated' | 'DocumentPolicyDeleted' | 'DocumentPolicyAccessed' | 'DocumentRoleCreated' | 'DocumentRoleUpdated' | 'DocumentRoleDeleted' | 'DocumentContentCreated' | 'DocumentContentStatusUpdated' | 'DocumentContentUpdated' | 'DocumentContentDeleted' | 'DocumentContentReadOnly' | 'ShareCreated' | 'ShareUpdated' | 'ShareDeleted' | 'IntegrationCreated' | 'IntegrationUpdated' | 'IntegrationDeleted' | 'WebhookCreated' | 'WebhookUpdated' | 'WebhookDeleted' | 'MarketplaceItemCreated' | 'MarketplaceItemUpdated' | 'MarketplaceItemApproveUpdated' | 'MarketplaceItemDeleted' | 'RuleCreated' | 'RuleUpdated' | 'RuleDeleted' | 'RuleExecutionCreated' | 'RuleExecutionDeleted'>} eventTypes The ID of the __Template__ from which we was generate this flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveObjectEvent(eventTypes, options) {
            return localVarFp
                .retrieveObjectEvent(eventTypes, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuditApi - object-oriented interface
 * @export
 * @class AuditApi
 * @extends {BaseAPI}
 */
export class AuditApi extends BaseAPI {
    /**
     * Returns the last event object of a type.
     * @summary Retrieve last event object
     * @param {Array<'AdminCreated' | 'AdminUpdated' | 'AdminDeleted' | 'AdminEmailUpdated' | 'AdminPasswordUpdated' | 'AdminAccessed' | 'UserCreated' | 'UserUpdated' | 'UserDeleted' | 'UserTosAccepted' | 'UserEmailUpdated' | 'UserDisabled' | 'UserEnabled' | 'UserPasswordUpdated' | 'UserEmailVerified' | 'UserAccessed' | 'ProductCreated' | 'ProductUpdated' | 'ProductDeleted' | 'ProductCapabilitiesUpdated' | 'ProductQuotaCreated' | 'ProductQuotaUpdated' | 'ProductQuotaDeleted' | 'ProductQuotaDisabled' | 'ProductQuotaEnabled' | 'PaymentMethodCreated' | 'PaymentMethodUpdated' | 'PaymentMethodDeleted' | 'AddonCreated' | 'AddonUpdated' | 'AddonDeleted' | 'ContactCreated' | 'ContactUpdated' | 'ContactDeleted' | 'CurrencyCreated' | 'CurrencyUpdated' | 'CurrencyDeleted' | 'TaxRateCreated' | 'TaxRateUpdated' | 'TaxRateDeleted' | 'TaxRateDisabled' | 'FormFlowCreated' | 'FormFlowUpdated' | 'FormFlowSetDefault' | 'FormFlowDeleted' | 'FormFlowCompleted' | 'FormFlowShareCreated' | 'FormFlowShareUpdated' | 'FormFlowShareDeleted' | 'AccountCreated' | 'AccountDeleted' | 'AccountUpdated' | 'AccountTosAccepted' | 'AccountEnabled' | 'AccountDisabled' | 'AccountPolicyCreated' | 'AccountPolicyUpdated' | 'AccountPolicyDeleted' | 'AccountPolicyAccessed' | 'AccountRoleCreated' | 'AccountRoleUpdated' | 'AccountRoleDeleted' | 'AccountTokenCreated' | 'AccountTokenKeyUpdated' | 'AccountTokenUpdated' | 'AccountTokenDeleted' | 'AccountTokenUsedAtUpdated' | 'AccountSamlCreated' | 'AccountSamlUpdated' | 'AccountSamlDeleted' | 'AccountIntegrationEnable' | 'AccountIntegrationUpdated' | 'AccountIntegrationGenerateKey' | 'AccountIntegrationDisable' | 'AccountIntegrationExecuted' | 'TemplateCreated' | 'TemplateUpdated' | 'TemplateDeleted' | 'TemplatePublished' | 'TemplateUnPublished' | 'TemplateDestinationFolderUpdated' | 'TagCreated' | 'TagUpdated' | 'TagDeleted' | 'FolderCreated' | 'FolderUpdated' | 'FolderDeleted' | 'PartyCreated' | 'PartyUpdated' | 'PartyDeleted' | 'SecureNotificationCreated' | 'SecureNotificationUpdated' | 'SecureNotificationDeleted' | 'ReminderCreated' | 'ReminderUpdated' | 'ReminderNotified' | 'ReminderDeleted' | 'SignatureCreated' | 'SignatureUpdated' | 'SignatureRequested' | 'SignatureSigned' | 'SignatureDeleted' | 'DocumentFullySigned' | 'PlanCreated' | 'PlanUpdated' | 'PlanDeleted' | 'PlanDisabled' | 'PlanEnabled' | 'SubscriptionCreated' | 'SubscriptionUpdated' | 'SubscriptionDeleted' | 'SubscriptionCancelled' | 'SubscriptionCapabilitiesUpdated' | 'StripeChargeFailed' | 'StripeChargeSucceeded' | 'StripeCustomerCreated' | 'StripeCustomerDeleted' | 'StripeCustomerDiscountCreated' | 'StripeCustomerDiscountDeleted' | 'StripeCustomerDiscountUpdated' | 'StripeCustomerSourceCreated' | 'StripeCustomerSourceUpdated' | 'StripeCustomerSubscriptionCreated' | 'StripeCustomerSubscriptionDeleted' | 'StripeCustomerSubscriptionPendingUpdateApplied' | 'StripeCustomerSubscriptionPendingUpdateExpired' | 'StripeCustomerSubscriptionTrialWillEnd' | 'StripeCustomerSubscriptionUpdated' | 'StripeCustomerUpdated' | 'StripeInvoiceCreated' | 'StripeInvoiceFinalizationFailed' | 'StripeInvoiceFinalized' | 'StripeInvoiceItemCreated' | 'StripeInvoiceItemDeleted' | 'StripeInvoiceItemUpdated' | 'StripeInvoicePaid' | 'StripeInvoicePaymentFailed' | 'StripeInvoicePaymentSucceeded' | 'StripeInvoiceSent' | 'StripeInvoiceUpcoming' | 'StripeInvoiceUpdated' | 'StripeIssuingAuthorizationRequest' | 'StripeIssuingAuthorizationUpdated' | 'StripeIssuingCardCreated' | 'StripeIssuingCardHolderCreated' | 'StripeIssuingCardHolderUpdated' | 'StripeIssuingCardUpdated' | 'StripePaymentIntentAmountCapturableUpdated' | 'StripePaymentIntentCanceled' | 'StripePaymentIntentCreated' | 'StripePaymentIntentPaymentFailed' | 'StripePaymentIntentSucceeded' | 'StripePaymentMethodAttached' | 'StripePaymentMethodDetached' | 'StripePaymentMethodUpdated' | 'StripePlanCreated' | 'StripePlanDeleted' | 'StripePlanUpdated' | 'StripePriceCreated' | 'StripePriceDeleted' | 'StripePriceUpdated' | 'StripeProductCreated' | 'StripeProductDeleted' | 'StripeProductUpdated' | 'StripePromotionCodeCreated' | 'StripePromotionCodeUpdated' | 'StripeSetupIntentCreated' | 'StripeSetupIntentFailed' | 'StripeSetupIntentRequiresAction' | 'StripeSetupIntentSucceeded' | 'StripeTaxRateCreated' | 'StripeTaxRateDeleted' | 'StripeTaxRateUpdated' | 'StripeCustomerTaxIdCreated' | 'StripeCustomerTaxIdDeleted' | 'StripeCustomerTaxIdUpdated' | 'CategoryCreated' | 'CategoryUpdated' | 'CategoryDeleted' | 'DocumentFullyApproved' | 'DocumentFullyRejected' | 'ApprovalCreated' | 'ApprovalUpdated' | 'ApprovalDeleted' | 'ApprovalRequested' | 'ApprovalApproved' | 'ApprovalRejected' | 'ApprovalMessageCreated' | 'ApprovalMessageUpdated' | 'ApprovalMessageDeleted' | 'DocumentCreated' | 'DocumentUpdated' | 'DocumentStatusUpdated' | 'DocumentDeleted' | 'DocumentCancelled' | 'DocumentArchived' | 'DocumentRestored' | 'DocumentActivated' | 'DocumentToExpired' | 'DocumentExpired' | 'DocumentDestinationFolderUpdated' | 'DocumentPolicyCreated' | 'DocumentPolicyUpdated' | 'DocumentPolicyDeleted' | 'DocumentPolicyAccessed' | 'DocumentRoleCreated' | 'DocumentRoleUpdated' | 'DocumentRoleDeleted' | 'DocumentContentCreated' | 'DocumentContentStatusUpdated' | 'DocumentContentUpdated' | 'DocumentContentDeleted' | 'DocumentContentReadOnly' | 'ShareCreated' | 'ShareUpdated' | 'ShareDeleted' | 'IntegrationCreated' | 'IntegrationUpdated' | 'IntegrationDeleted' | 'WebhookCreated' | 'WebhookUpdated' | 'WebhookDeleted' | 'MarketplaceItemCreated' | 'MarketplaceItemUpdated' | 'MarketplaceItemApproveUpdated' | 'MarketplaceItemDeleted' | 'RuleCreated' | 'RuleUpdated' | 'RuleDeleted' | 'RuleExecutionCreated' | 'RuleExecutionDeleted'>} eventTypes The ID of the __Template__ from which we was generate this flow.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApi
     */
    retrieveObjectEvent(eventTypes, options) {
        return AuditApiFp(this.configuration)
            .retrieveObjectEvent(eventTypes, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGetCsrfToken: async (options = {}) => {
            const localVarPath = `/vapp/auth/csrf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change password
         * @summary Change password
         * @param {ChangePasswordInput} changePasswordInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordInput, options = {}) => {
            // verify required parameter 'changePasswordInput' is not null or undefined
            assertParamExists('changePassword', 'changePasswordInput', changePasswordInput);
            const localVarPath = `/vapp/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Forgot password
         * @summary Forgot password
         * @param {ForgotPasswordInput} forgotPasswordInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (forgotPasswordInput, options = {}) => {
            // verify required parameter 'forgotPasswordInput' is not null or undefined
            assertParamExists('forgotPassword', 'forgotPasswordInput', forgotPasswordInput);
            const localVarPath = `/vapp/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirect google provider
         * @summary Redirect google provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCallback: async (options = {}) => {
            const localVarPath = `/vapp/auth/provider/google/cb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify google one tap credential and redirect
         * @summary Verify google one tap credential and redirect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleOneTapCallback: async (options = {}) => {
            const localVarPath = `/vapp/auth/provider/googleonetap/cb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign in with local provider
         * @summary Sign in local
         * @param {SignInLocalInput} signInLocalInput Sign in body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (signInLocalInput, options = {}) => {
            // verify required parameter 'signInLocalInput' is not null or undefined
            assertParamExists('login', 'signInLocalInput', signInLocalInput);
            const localVarPath = `/vapp/auth/provider/local`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(signInLocalInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign in with google provider
         * @summary Sign in google
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginGoogle: async (options = {}) => {
            const localVarPath = `/vapp/auth/provider/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign in with google provider
         * @summary Sign in google
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSaml: async (options = {}) => {
            const localVarPath = `/vapp/auth/provider/saml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign in with token provider
         * @summary Sign in token
         * @param {string} [xTokenAccess] Token access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginToken: async (xTokenAccess, options = {}) => {
            const localVarPath = `/vapp/auth/provider/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTokenAccess != null) {
                localVarHeaderParameter['x-token-access'] = String(xTokenAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign out
         * @summary Sign out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options = {}) => {
            const localVarPath = `/vapp/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirect magic link provider
         * @summary Redirect magic link provider
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magicCallback: async (token, options = {}) => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('magicCallback', 'token', token);
            const localVarPath = `/vapp/auth/provider/magic/cb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign up
         * @summary Sign up
         * @param {SignUpInput} signUpInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (signUpInput, options = {}) => {
            // verify required parameter 'signUpInput' is not null or undefined
            assertParamExists('register', 'signUpInput', signUpInput);
            const localVarPath = `/vapp/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(signUpInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirect saml provider
         * @summary Redirect saml provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        samlCallback: async (options = {}) => {
            const localVarPath = `/vapp/auth/provider/saml/cb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerGetCsrfToken(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerGetCsrfToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Change password
         * @summary Change password
         * @param {ChangePasswordInput} changePasswordInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Forgot password
         * @summary Forgot password
         * @param {ForgotPasswordInput} forgotPasswordInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(forgotPasswordInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(forgotPasswordInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Redirect google provider
         * @summary Redirect google provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleCallback(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleCallback(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify google one tap credential and redirect
         * @summary Verify google one tap credential and redirect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleOneTapCallback(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleOneTapCallback(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sign in with local provider
         * @summary Sign in local
         * @param {SignInLocalInput} signInLocalInput Sign in body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(signInLocalInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(signInLocalInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sign in with google provider
         * @summary Sign in google
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginGoogle(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginGoogle(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sign in with google provider
         * @summary Sign in google
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginSaml(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginSaml(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sign in with token provider
         * @summary Sign in token
         * @param {string} [xTokenAccess] Token access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginToken(xTokenAccess, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginToken(xTokenAccess, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sign out
         * @summary Sign out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Redirect magic link provider
         * @summary Redirect magic link provider
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async magicCallback(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.magicCallback(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sign up
         * @summary Sign up
         * @param {SignUpInput} signUpInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(signUpInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(signUpInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Redirect saml provider
         * @summary Redirect saml provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async samlCallback(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.samlCallback(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGetCsrfToken(options) {
            return localVarFp
                .authControllerGetCsrfToken(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Change password
         * @summary Change password
         * @param {ChangePasswordInput} changePasswordInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordInput, options) {
            return localVarFp
                .changePassword(changePasswordInput, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Forgot password
         * @summary Forgot password
         * @param {ForgotPasswordInput} forgotPasswordInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(forgotPasswordInput, options) {
            return localVarFp
                .forgotPassword(forgotPasswordInput, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Redirect google provider
         * @summary Redirect google provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCallback(options) {
            return localVarFp
                .googleCallback(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Verify google one tap credential and redirect
         * @summary Verify google one tap credential and redirect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleOneTapCallback(options) {
            return localVarFp
                .googleOneTapCallback(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sign in with local provider
         * @summary Sign in local
         * @param {SignInLocalInput} signInLocalInput Sign in body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(signInLocalInput, options) {
            return localVarFp
                .login(signInLocalInput, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sign in with google provider
         * @summary Sign in google
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginGoogle(options) {
            return localVarFp
                .loginGoogle(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sign in with google provider
         * @summary Sign in google
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSaml(options) {
            return localVarFp
                .loginSaml(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sign in with token provider
         * @summary Sign in token
         * @param {string} [xTokenAccess] Token access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginToken(xTokenAccess, options) {
            return localVarFp
                .loginToken(xTokenAccess, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sign out
         * @summary Sign out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return localVarFp
                .logout(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Redirect magic link provider
         * @summary Redirect magic link provider
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magicCallback(token, options) {
            return localVarFp
                .magicCallback(token, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sign up
         * @summary Sign up
         * @param {SignUpInput} signUpInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(signUpInput, options) {
            return localVarFp
                .register(signUpInput, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Redirect saml provider
         * @summary Redirect saml provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        samlCallback(options) {
            return localVarFp
                .samlCallback(options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    authControllerGetCsrfToken(options) {
        return AuthApiFp(this.configuration)
            .authControllerGetCsrfToken(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Change password
     * @summary Change password
     * @param {ChangePasswordInput} changePasswordInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    changePassword(changePasswordInput, options) {
        return AuthApiFp(this.configuration)
            .changePassword(changePasswordInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Forgot password
     * @summary Forgot password
     * @param {ForgotPasswordInput} forgotPasswordInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    forgotPassword(forgotPasswordInput, options) {
        return AuthApiFp(this.configuration)
            .forgotPassword(forgotPasswordInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Redirect google provider
     * @summary Redirect google provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    googleCallback(options) {
        return AuthApiFp(this.configuration)
            .googleCallback(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Verify google one tap credential and redirect
     * @summary Verify google one tap credential and redirect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    googleOneTapCallback(options) {
        return AuthApiFp(this.configuration)
            .googleOneTapCallback(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sign in with local provider
     * @summary Sign in local
     * @param {SignInLocalInput} signInLocalInput Sign in body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    login(signInLocalInput, options) {
        return AuthApiFp(this.configuration)
            .login(signInLocalInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sign in with google provider
     * @summary Sign in google
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    loginGoogle(options) {
        return AuthApiFp(this.configuration)
            .loginGoogle(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sign in with google provider
     * @summary Sign in google
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    loginSaml(options) {
        return AuthApiFp(this.configuration)
            .loginSaml(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sign in with token provider
     * @summary Sign in token
     * @param {string} [xTokenAccess] Token access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    loginToken(xTokenAccess, options) {
        return AuthApiFp(this.configuration)
            .loginToken(xTokenAccess, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sign out
     * @summary Sign out
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    logout(options) {
        return AuthApiFp(this.configuration)
            .logout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Redirect magic link provider
     * @summary Redirect magic link provider
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    magicCallback(token, options) {
        return AuthApiFp(this.configuration)
            .magicCallback(token, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sign up
     * @summary Sign up
     * @param {SignUpInput} signUpInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    register(signUpInput, options) {
        return AuthApiFp(this.configuration)
            .register(signUpInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Redirect saml provider
     * @summary Redirect saml provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    samlCallback(options) {
        return AuthApiFp(this.configuration)
            .samlCallback(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a list of your categories. The categories are returned sorted by __createdAt__ date by default.
         * @summary List all categories
         * @param {string} [nameEn] The category name.
         * @param {string} [group] Name of the group in which the category belongs to.
         * @param {string} [search] Search category by name
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCategories: async (nameEn, group, search, size, orderBy, sortBy, page, options = {}) => {
            const localVarPath = `/v1/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (nameEn !== undefined) {
                localVarQueryParameter['nameEn'] = nameEn;
            }
            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a list of your categories. The categories are returned sorted by __createdAt__ date by default.
         * @summary List all categories
         * @param {string} [nameEn] The category name.
         * @param {string} [group] Name of the group in which the category belongs to.
         * @param {string} [search] Search category by name
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveCategories(nameEn, group, search, size, orderBy, sortBy, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveCategories(nameEn, group, search, size, orderBy, sortBy, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CategoriesApiFp(configuration);
    return {
        /**
         * Returns a list of your categories. The categories are returned sorted by __createdAt__ date by default.
         * @summary List all categories
         * @param {string} [nameEn] The category name.
         * @param {string} [group] Name of the group in which the category belongs to.
         * @param {string} [search] Search category by name
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCategories(nameEn, group, search, size, orderBy, sortBy, page, options) {
            return localVarFp
                .retrieveCategories(nameEn, group, search, size, orderBy, sortBy, page, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
    /**
     * Returns a list of your categories. The categories are returned sorted by __createdAt__ date by default.
     * @summary List all categories
     * @param {string} [nameEn] The category name.
     * @param {string} [group] Name of the group in which the category belongs to.
     * @param {string} [search] Search category by name
     * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
     * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
     * @param {string} [sortBy] A list of properties that you can select to sort the list by.
     * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    retrieveCategories(nameEn, group, search, size, orderBy, sortBy, page, options) {
        return CategoriesApiFp(this.configuration)
            .retrieveCategories(nameEn, group, search, size, orderBy, sortBy, page, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Delete a contact
         * @summary Delete a contact
         * @param {string} id
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: async (id, bounselAccount, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteContact', 'id', id);
            const localVarPath = `/vapp/contacts/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'DELETE',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            if (bounselAccount != null) {
                localVarHeaderParameter['bounsel-account'] = String(bounselAccount);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a contact
         * @summary Retrieve a contact
         * @param {string} id
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveContact: async (id, bounselAccount, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveContact', 'id', id);
            const localVarPath = `/vapp/contacts/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            if (bounselAccount != null) {
                localVarHeaderParameter['bounsel-account'] = String(bounselAccount);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve contacts
         * @summary Retrieve contacts
         * @param {number} [page] Page number
         * @param {number} [size] Size per request
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveContacts: async (page, size, bounselAccount, options = {}) => {
            const localVarPath = `/vapp/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (bounselAccount != null) {
                localVarHeaderParameter['bounsel-account'] = String(bounselAccount);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update a contact
         * @summary Create or update a contact
         * @param {UpdateOrCreateContactInput} updateOrCreateContactInput
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertContact: async (updateOrCreateContactInput, bounselAccount, options = {}) => {
            // verify required parameter 'updateOrCreateContactInput' is not null or undefined
            assertParamExists('upsertContact', 'updateOrCreateContactInput', updateOrCreateContactInput);
            const localVarPath = `/vapp/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            if (bounselAccount != null) {
                localVarHeaderParameter['bounsel-account'] = String(bounselAccount);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrCreateContactInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration);
    return {
        /**
         * Delete a contact
         * @summary Delete a contact
         * @param {string} id
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContact(id, bounselAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContact(id, bounselAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a contact
         * @summary Retrieve a contact
         * @param {string} id
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveContact(id, bounselAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveContact(id, bounselAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve contacts
         * @summary Retrieve contacts
         * @param {number} [page] Page number
         * @param {number} [size] Size per request
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveContacts(page, size, bounselAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveContacts(page, size, bounselAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create or update a contact
         * @summary Create or update a contact
         * @param {UpdateOrCreateContactInput} updateOrCreateContactInput
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertContact(updateOrCreateContactInput, bounselAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertContact(updateOrCreateContactInput, bounselAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContactsApiFp(configuration);
    return {
        /**
         * Delete a contact
         * @summary Delete a contact
         * @param {string} id
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact(id, bounselAccount, options) {
            return localVarFp
                .deleteContact(id, bounselAccount, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a contact
         * @summary Retrieve a contact
         * @param {string} id
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveContact(id, bounselAccount, options) {
            return localVarFp
                .retrieveContact(id, bounselAccount, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve contacts
         * @summary Retrieve contacts
         * @param {number} [page] Page number
         * @param {number} [size] Size per request
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveContacts(page, size, bounselAccount, options) {
            return localVarFp
                .retrieveContacts(page, size, bounselAccount, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create or update a contact
         * @summary Create or update a contact
         * @param {UpdateOrCreateContactInput} updateOrCreateContactInput
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertContact(updateOrCreateContactInput, bounselAccount, options) {
            return localVarFp
                .upsertContact(updateOrCreateContactInput, bounselAccount, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     * Delete a contact
     * @summary Delete a contact
     * @param {string} id
     * @param {string} [bounselAccount] Active account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    deleteContact(id, bounselAccount, options) {
        return ContactsApiFp(this.configuration)
            .deleteContact(id, bounselAccount, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a contact
     * @summary Retrieve a contact
     * @param {string} id
     * @param {string} [bounselAccount] Active account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    retrieveContact(id, bounselAccount, options) {
        return ContactsApiFp(this.configuration)
            .retrieveContact(id, bounselAccount, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve contacts
     * @summary Retrieve contacts
     * @param {number} [page] Page number
     * @param {number} [size] Size per request
     * @param {string} [bounselAccount] Active account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    retrieveContacts(page, size, bounselAccount, options) {
        return ContactsApiFp(this.configuration)
            .retrieveContacts(page, size, bounselAccount, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create or update a contact
     * @summary Create or update a contact
     * @param {UpdateOrCreateContactInput} updateOrCreateContactInput
     * @param {string} [bounselAccount] Active account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    upsertContact(updateOrCreateContactInput, bounselAccount, options) {
        return ContactsApiFp(this.configuration)
            .upsertContact(updateOrCreateContactInput, bounselAccount, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a document by setting the values of the parameters passed. Any parameter that wasn’t provided will not be saved. If you don’t provide the variables required to complete your Template, the document will be saved as __Draft__.
         * @summary Create a document
         * @param {CreateDocumentFromTemplateInput} createDocumentFromTemplateInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentFromTemplate: async (createDocumentFromTemplateInput, options = {}) => {
            // verify required parameter 'createDocumentFromTemplateInput' is not null or undefined
            assertParamExists('createDocumentFromTemplate', 'createDocumentFromTemplateInput', createDocumentFromTemplateInput);
            const localVarPath = `/v1/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createDocumentFromTemplateInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes a document. It cannot be undone. Also immediately removes any version and relations with other objects.
         * @summary Delete a document
         * @param {string} id An unique identifier for the object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDocument', 'id', id);
            const localVarPath = `/v1/documents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'DELETE',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes a list of documents at once. It cannot be undone. Also immediately removes any version and relations with other objects.
         * @summary Delete documents
         * @param {Array<string>} ids An array of document IDs that is going to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocuments: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteDocuments', 'ids', ids);
            const localVarPath = `/v1/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'DELETE',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a file formatted to be downloaded. The download on the client is not automatic. For example: Using the response data you can convert an base64 to [.pdf, .word, …].
         * @summary Download a document
         * @param {string} id An unique identifier for the object.
         * @param {'base64' | 'binary' | 'url'} format A format to convert the document stored on our servers to be downloaded. The value must be one of the following options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument: async (id, format, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadDocument', 'id', id);
            // verify required parameter 'format' is not null or undefined
            assertParamExists('downloadDocument', 'format', format);
            const localVarPath = `/v1/documents/{id}/download`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Document object.
         * @summary Retrieve a document
         * @param {string} id An unique identifier for the object.
         * @param {Array<'account' | 'author' | 'fromDocument' | 'tags' | 'category'>} [expandable] Expanded params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDocument: async (id, expandable, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveDocument', 'id', id);
            const localVarPath = `/v1/documents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (expandable) {
                localVarQueryParameter['expandable'] = expandable;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of your available document status. The documents are returned sorted by createdAt date by default.
         * @summary List all document status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDocumentStatusList: async (options = {}) => {
            const localVarPath = `/v1/documents/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all your documents. They will be sorted by __createdAt__ date by default.
         * @summary List all documents
         * @param {string} [name] The document name without extension.
         * @param {string} [search] Search documents by name
         * @param {number} [folderId] The ID of the __Folder__ where the document is located on.
         * @param {'initial' | 'drafting' | 'toReview' | 'approved' | 'toSign' | 'signing' | 'signed' | 'pendingAction' | 'completed' | 'active' | 'toExpire' | 'expired' | 'cancelled'} [status] A filter on the list based on the __status__ field. The value must be a string that matches with the following options.
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDocuments: async (name, search, folderId, status, size, orderBy, sortBy, page, options = {}) => {
            const localVarPath = `/v1/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the specified document by setting the values of the parameters passed. Any parameters that wasn’t provided will be left unchanged. If you don’t provide the variables required to complete your document, they will be removed from it. Please think twice before removing any variable.
         * @summary Update a document
         * @param {string} id An unique identifier for the object.
         * @param {UpdateDocumentWithVariablesInput} updateDocumentWithVariablesInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument: async (id, updateDocumentWithVariablesInput, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDocument', 'id', id);
            // verify required parameter 'updateDocumentWithVariablesInput' is not null or undefined
            assertParamExists('updateDocument', 'updateDocumentWithVariablesInput', updateDocumentWithVariablesInput);
            const localVarPath = `/v1/documents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'PUT',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentWithVariablesInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update document status
         * @summary Update document status
         * @param {string} id An unique identifier for the object.
         * @param {UpdateDocumentStatusInput} updateDocumentStatusInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentStatus: async (id, updateDocumentStatusInput, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDocumentStatus', 'id', id);
            // verify required parameter 'updateDocumentStatusInput' is not null or undefined
            assertParamExists('updateDocumentStatus', 'updateDocumentStatusInput', updateDocumentStatusInput);
            const localVarPath = `/v1/documents/{id}/status`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'PUT',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentStatusInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a document by setting the values of the parameters passed. Any parameter that wasn’t provided will not be saved. If you don’t provide the variables required to complete your Template, the document will be saved as __Draft__.
         * @summary Create a document
         * @param {CreateDocumentFromTemplateInput} createDocumentFromTemplateInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentFromTemplate(createDocumentFromTemplateInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentFromTemplate(createDocumentFromTemplateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Permanently deletes a document. It cannot be undone. Also immediately removes any version and relations with other objects.
         * @summary Delete a document
         * @param {string} id An unique identifier for the object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Permanently deletes a list of documents at once. It cannot be undone. Also immediately removes any version and relations with other objects.
         * @summary Delete documents
         * @param {Array<string>} ids An array of document IDs that is going to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocuments(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocuments(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a file formatted to be downloaded. The download on the client is not automatic. For example: Using the response data you can convert an base64 to [.pdf, .word, …].
         * @summary Download a document
         * @param {string} id An unique identifier for the object.
         * @param {'base64' | 'binary' | 'url'} format A format to convert the document stored on our servers to be downloaded. The value must be one of the following options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocument(id, format, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocument(id, format, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Document object.
         * @summary Retrieve a document
         * @param {string} id An unique identifier for the object.
         * @param {Array<'account' | 'author' | 'fromDocument' | 'tags' | 'category'>} [expandable] Expanded params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDocument(id, expandable, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveDocument(id, expandable, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of your available document status. The documents are returned sorted by createdAt date by default.
         * @summary List all document status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDocumentStatusList(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveDocumentStatusList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of all your documents. They will be sorted by __createdAt__ date by default.
         * @summary List all documents
         * @param {string} [name] The document name without extension.
         * @param {string} [search] Search documents by name
         * @param {number} [folderId] The ID of the __Folder__ where the document is located on.
         * @param {'initial' | 'drafting' | 'toReview' | 'approved' | 'toSign' | 'signing' | 'signed' | 'pendingAction' | 'completed' | 'active' | 'toExpire' | 'expired' | 'cancelled'} [status] A filter on the list based on the __status__ field. The value must be a string that matches with the following options.
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDocuments(name, search, folderId, status, size, orderBy, sortBy, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveDocuments(name, search, folderId, status, size, orderBy, sortBy, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the specified document by setting the values of the parameters passed. Any parameters that wasn’t provided will be left unchanged. If you don’t provide the variables required to complete your document, they will be removed from it. Please think twice before removing any variable.
         * @summary Update a document
         * @param {string} id An unique identifier for the object.
         * @param {UpdateDocumentWithVariablesInput} updateDocumentWithVariablesInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocument(id, updateDocumentWithVariablesInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocument(id, updateDocumentWithVariablesInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update document status
         * @summary Update document status
         * @param {string} id An unique identifier for the object.
         * @param {UpdateDocumentStatusInput} updateDocumentStatusInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentStatus(id, updateDocumentStatusInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumentStatus(id, updateDocumentStatusInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocumentsApiFp(configuration);
    return {
        /**
         * Create a document by setting the values of the parameters passed. Any parameter that wasn’t provided will not be saved. If you don’t provide the variables required to complete your Template, the document will be saved as __Draft__.
         * @summary Create a document
         * @param {CreateDocumentFromTemplateInput} createDocumentFromTemplateInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentFromTemplate(createDocumentFromTemplateInput, options) {
            return localVarFp
                .createDocumentFromTemplate(createDocumentFromTemplateInput, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes a document. It cannot be undone. Also immediately removes any version and relations with other objects.
         * @summary Delete a document
         * @param {string} id An unique identifier for the object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(id, options) {
            return localVarFp
                .deleteDocument(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes a list of documents at once. It cannot be undone. Also immediately removes any version and relations with other objects.
         * @summary Delete documents
         * @param {Array<string>} ids An array of document IDs that is going to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocuments(ids, options) {
            return localVarFp
                .deleteDocuments(ids, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a file formatted to be downloaded. The download on the client is not automatic. For example: Using the response data you can convert an base64 to [.pdf, .word, …].
         * @summary Download a document
         * @param {string} id An unique identifier for the object.
         * @param {'base64' | 'binary' | 'url'} format A format to convert the document stored on our servers to be downloaded. The value must be one of the following options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument(id, format, options) {
            return localVarFp
                .downloadDocument(id, format, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Document object.
         * @summary Retrieve a document
         * @param {string} id An unique identifier for the object.
         * @param {Array<'account' | 'author' | 'fromDocument' | 'tags' | 'category'>} [expandable] Expanded params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDocument(id, expandable, options) {
            return localVarFp
                .retrieveDocument(id, expandable, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of your available document status. The documents are returned sorted by createdAt date by default.
         * @summary List all document status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDocumentStatusList(options) {
            return localVarFp
                .retrieveDocumentStatusList(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of all your documents. They will be sorted by __createdAt__ date by default.
         * @summary List all documents
         * @param {string} [name] The document name without extension.
         * @param {string} [search] Search documents by name
         * @param {number} [folderId] The ID of the __Folder__ where the document is located on.
         * @param {'initial' | 'drafting' | 'toReview' | 'approved' | 'toSign' | 'signing' | 'signed' | 'pendingAction' | 'completed' | 'active' | 'toExpire' | 'expired' | 'cancelled'} [status] A filter on the list based on the __status__ field. The value must be a string that matches with the following options.
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDocuments(name, search, folderId, status, size, orderBy, sortBy, page, options) {
            return localVarFp
                .retrieveDocuments(name, search, folderId, status, size, orderBy, sortBy, page, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Updates the specified document by setting the values of the parameters passed. Any parameters that wasn’t provided will be left unchanged. If you don’t provide the variables required to complete your document, they will be removed from it. Please think twice before removing any variable.
         * @summary Update a document
         * @param {string} id An unique identifier for the object.
         * @param {UpdateDocumentWithVariablesInput} updateDocumentWithVariablesInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument(id, updateDocumentWithVariablesInput, options) {
            return localVarFp
                .updateDocument(id, updateDocumentWithVariablesInput, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update document status
         * @summary Update document status
         * @param {string} id An unique identifier for the object.
         * @param {UpdateDocumentStatusInput} updateDocumentStatusInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentStatus(id, updateDocumentStatusInput, options) {
            return localVarFp
                .updateDocumentStatus(id, updateDocumentStatusInput, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * Create a document by setting the values of the parameters passed. Any parameter that wasn’t provided will not be saved. If you don’t provide the variables required to complete your Template, the document will be saved as __Draft__.
     * @summary Create a document
     * @param {CreateDocumentFromTemplateInput} createDocumentFromTemplateInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    createDocumentFromTemplate(createDocumentFromTemplateInput, options) {
        return DocumentsApiFp(this.configuration)
            .createDocumentFromTemplate(createDocumentFromTemplateInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Permanently deletes a document. It cannot be undone. Also immediately removes any version and relations with other objects.
     * @summary Delete a document
     * @param {string} id An unique identifier for the object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    deleteDocument(id, options) {
        return DocumentsApiFp(this.configuration)
            .deleteDocument(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Permanently deletes a list of documents at once. It cannot be undone. Also immediately removes any version and relations with other objects.
     * @summary Delete documents
     * @param {Array<string>} ids An array of document IDs that is going to remove.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    deleteDocuments(ids, options) {
        return DocumentsApiFp(this.configuration)
            .deleteDocuments(ids, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a file formatted to be downloaded. The download on the client is not automatic. For example: Using the response data you can convert an base64 to [.pdf, .word, …].
     * @summary Download a document
     * @param {string} id An unique identifier for the object.
     * @param {'base64' | 'binary' | 'url'} format A format to convert the document stored on our servers to be downloaded. The value must be one of the following options.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    downloadDocument(id, format, options) {
        return DocumentsApiFp(this.configuration)
            .downloadDocument(id, format, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a Document object.
     * @summary Retrieve a document
     * @param {string} id An unique identifier for the object.
     * @param {Array<'account' | 'author' | 'fromDocument' | 'tags' | 'category'>} [expandable] Expanded params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    retrieveDocument(id, expandable, options) {
        return DocumentsApiFp(this.configuration)
            .retrieveDocument(id, expandable, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of your available document status. The documents are returned sorted by createdAt date by default.
     * @summary List all document status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    retrieveDocumentStatusList(options) {
        return DocumentsApiFp(this.configuration)
            .retrieveDocumentStatusList(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of all your documents. They will be sorted by __createdAt__ date by default.
     * @summary List all documents
     * @param {string} [name] The document name without extension.
     * @param {string} [search] Search documents by name
     * @param {number} [folderId] The ID of the __Folder__ where the document is located on.
     * @param {'initial' | 'drafting' | 'toReview' | 'approved' | 'toSign' | 'signing' | 'signed' | 'pendingAction' | 'completed' | 'active' | 'toExpire' | 'expired' | 'cancelled'} [status] A filter on the list based on the __status__ field. The value must be a string that matches with the following options.
     * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
     * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
     * @param {string} [sortBy] A list of properties that you can select to sort the list by.
     * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    retrieveDocuments(name, search, folderId, status, size, orderBy, sortBy, page, options) {
        return DocumentsApiFp(this.configuration)
            .retrieveDocuments(name, search, folderId, status, size, orderBy, sortBy, page, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the specified document by setting the values of the parameters passed. Any parameters that wasn’t provided will be left unchanged. If you don’t provide the variables required to complete your document, they will be removed from it. Please think twice before removing any variable.
     * @summary Update a document
     * @param {string} id An unique identifier for the object.
     * @param {UpdateDocumentWithVariablesInput} updateDocumentWithVariablesInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    updateDocument(id, updateDocumentWithVariablesInput, options) {
        return DocumentsApiFp(this.configuration)
            .updateDocument(id, updateDocumentWithVariablesInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update document status
     * @summary Update document status
     * @param {string} id An unique identifier for the object.
     * @param {UpdateDocumentStatusInput} updateDocumentStatusInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    updateDocumentStatus(id, updateDocumentStatusInput, options) {
        return DocumentsApiFp(this.configuration)
            .updateDocumentStatus(id, updateDocumentStatusInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a document content file
         * @summary Retrieve a document content file
         * @param {string} token
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveContentFile: async (token, bounselAccount, options = {}) => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('retrieveContentFile', 'token', token);
            const localVarPath = `/vapp/files/content/{token}`.replace(`{${'token'}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            if (bounselAccount != null) {
                localVarHeaderParameter['bounsel-account'] = String(bounselAccount);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a document content file
         * @summary Retrieve a document content file
         * @param {string} token
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveContentFile(token, bounselAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveContentFile(token, bounselAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FilesApiFp(configuration);
    return {
        /**
         * Retrieve a document content file
         * @summary Retrieve a document content file
         * @param {string} token
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveContentFile(token, bounselAccount, options) {
            return localVarFp
                .retrieveContentFile(token, bounselAccount, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
export class FilesApi extends BaseAPI {
    /**
     * Retrieve a document content file
     * @summary Retrieve a document content file
     * @param {string} token
     * @param {string} [bounselAccount] Active account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    retrieveContentFile(token, bounselAccount, options) {
        return FilesApiFp(this.configuration)
            .retrieveContentFile(token, bounselAccount, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FlowsApi - axios parameter creator
 * @export
 */
export const FlowsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns the sub-flows shares details from a document.
         * @summary Document flow shares
         * @param {string} documentId The ID of the __Document__ from which we was generate this flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFormFlowSharesByDocumentID: async (documentId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('retrieveFormFlowSharesByDocumentID', 'documentId', documentId);
            const localVarPath = `/v1/flows/document/shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (documentId !== undefined) {
                localVarQueryParameter['documentId'] = documentId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the master flow shares details from a template.
         * @summary Template flow shares
         * @param {string} templateId The ID of the __Template__ from which we was generate this flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMasterFormFlowSharesByTemplateID: async (templateId, options = {}) => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('retrieveMasterFormFlowSharesByTemplateID', 'templateId', templateId);
            const localVarPath = `/v1/flows/template/shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FlowsApi - functional programming interface
 * @export
 */
export const FlowsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FlowsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns the sub-flows shares details from a document.
         * @summary Document flow shares
         * @param {string} documentId The ID of the __Document__ from which we was generate this flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveFormFlowSharesByDocumentID(documentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveFormFlowSharesByDocumentID(documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the master flow shares details from a template.
         * @summary Template flow shares
         * @param {string} templateId The ID of the __Template__ from which we was generate this flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveMasterFormFlowSharesByTemplateID(templateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveMasterFormFlowSharesByTemplateID(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * FlowsApi - factory interface
 * @export
 */
export const FlowsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FlowsApiFp(configuration);
    return {
        /**
         * Returns the sub-flows shares details from a document.
         * @summary Document flow shares
         * @param {string} documentId The ID of the __Document__ from which we was generate this flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFormFlowSharesByDocumentID(documentId, options) {
            return localVarFp
                .retrieveFormFlowSharesByDocumentID(documentId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns the master flow shares details from a template.
         * @summary Template flow shares
         * @param {string} templateId The ID of the __Template__ from which we was generate this flow.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMasterFormFlowSharesByTemplateID(templateId, options) {
            return localVarFp
                .retrieveMasterFormFlowSharesByTemplateID(templateId, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FlowsApi - object-oriented interface
 * @export
 * @class FlowsApi
 * @extends {BaseAPI}
 */
export class FlowsApi extends BaseAPI {
    /**
     * Returns the sub-flows shares details from a document.
     * @summary Document flow shares
     * @param {string} documentId The ID of the __Document__ from which we was generate this flow.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    retrieveFormFlowSharesByDocumentID(documentId, options) {
        return FlowsApiFp(this.configuration)
            .retrieveFormFlowSharesByDocumentID(documentId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the master flow shares details from a template.
     * @summary Template flow shares
     * @param {string} templateId The ID of the __Template__ from which we was generate this flow.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    retrieveMasterFormFlowSharesByTemplateID(templateId, options) {
        return FlowsApiFp(this.configuration)
            .retrieveMasterFormFlowSharesByTemplateID(templateId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FolderApi - axios parameter creator
 * @export
 */
export const FolderApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a list of your folders. The folders are returned sorted by __createdAt__ date by default.
         * @summary List all folders
         * @param {string} [name] Folder\&#39;s name
         * @param {string} [parent] Parent folder
         * @param {string} [search] Search folders
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFolders: async (name, parent, search, size, orderBy, sortBy, page, options = {}) => {
            const localVarPath = `/v1/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (parent !== undefined) {
                localVarQueryParameter['parent'] = parent;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FolderApi - functional programming interface
 * @export
 */
export const FolderApiFp = function (configuration) {
    const localVarAxiosParamCreator = FolderApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a list of your folders. The folders are returned sorted by __createdAt__ date by default.
         * @summary List all folders
         * @param {string} [name] Folder\&#39;s name
         * @param {string} [parent] Parent folder
         * @param {string} [search] Search folders
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveFolders(name, parent, search, size, orderBy, sortBy, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveFolders(name, parent, search, size, orderBy, sortBy, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * FolderApi - factory interface
 * @export
 */
export const FolderApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FolderApiFp(configuration);
    return {
        /**
         * Returns a list of your folders. The folders are returned sorted by __createdAt__ date by default.
         * @summary List all folders
         * @param {string} [name] Folder\&#39;s name
         * @param {string} [parent] Parent folder
         * @param {string} [search] Search folders
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFolders(name, parent, search, size, orderBy, sortBy, page, options) {
            return localVarFp
                .retrieveFolders(name, parent, search, size, orderBy, sortBy, page, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FolderApi - object-oriented interface
 * @export
 * @class FolderApi
 * @extends {BaseAPI}
 */
export class FolderApi extends BaseAPI {
    /**
     * Returns a list of your folders. The folders are returned sorted by __createdAt__ date by default.
     * @summary List all folders
     * @param {string} [name] Folder\&#39;s name
     * @param {string} [parent] Parent folder
     * @param {string} [search] Search folders
     * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
     * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
     * @param {string} [sortBy] A list of properties that you can select to sort the list by.
     * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FolderApi
     */
    retrieveFolders(name, parent, search, size, orderBy, sortBy, page, options) {
        return FolderApiFp(this.configuration)
            .retrieveFolders(name, parent, search, size, orderBy, sortBy, page, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FormFlowSharesApi - axios parameter creator
 * @export
 */
export const FormFlowSharesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a form flow share cover image
         * @summary Retrieve a form flow share cover image
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCoverImage: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateCoverImage', 'id', id);
            const localVarPath = `/formFlowShares/{id}/cover`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FormFlowSharesApi - functional programming interface
 * @export
 */
export const FormFlowSharesApiFp = function (configuration) {
    const localVarAxiosParamCreator = FormFlowSharesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a form flow share cover image
         * @summary Retrieve a form flow share cover image
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCoverImage(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCoverImage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * FormFlowSharesApi - factory interface
 * @export
 */
export const FormFlowSharesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FormFlowSharesApiFp(configuration);
    return {
        /**
         * Retrieve a form flow share cover image
         * @summary Retrieve a form flow share cover image
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCoverImage(id, options) {
            return localVarFp
                .generateCoverImage(id, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FormFlowSharesApi - object-oriented interface
 * @export
 * @class FormFlowSharesApi
 * @extends {BaseAPI}
 */
export class FormFlowSharesApi extends BaseAPI {
    /**
     * Retrieve a form flow share cover image
     * @summary Retrieve a form flow share cover image
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormFlowSharesApi
     */
    generateCoverImage(id, options) {
        return FormFlowSharesApiFp(this.configuration)
            .generateCoverImage(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HooksApi - axios parameter creator
 * @export
 */
export const HooksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Listen email events hook
         * @summary Listen email events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailEvents: async (options = {}) => {
            const localVarPath = `/vapp/hooks/email/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Listen stripe events hook
         * @summary Listen stripe events
         * @param {string} stripeSignature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeEvents: async (stripeSignature, options = {}) => {
            // verify required parameter 'stripeSignature' is not null or undefined
            assertParamExists('stripeEvents', 'stripeSignature', stripeSignature);
            const localVarPath = `/vapp/hooks/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (stripeSignature != null) {
                localVarHeaderParameter['stripe-signature'] = String(stripeSignature);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HooksApi - functional programming interface
 * @export
 */
export const HooksApiFp = function (configuration) {
    const localVarAxiosParamCreator = HooksApiAxiosParamCreator(configuration);
    return {
        /**
         * Listen email events hook
         * @summary Listen email events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailEvents(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailEvents(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Listen stripe events hook
         * @summary Listen stripe events
         * @param {string} stripeSignature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripeEvents(stripeSignature, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripeEvents(stripeSignature, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * HooksApi - factory interface
 * @export
 */
export const HooksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HooksApiFp(configuration);
    return {
        /**
         * Listen email events hook
         * @summary Listen email events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailEvents(options) {
            return localVarFp
                .emailEvents(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Listen stripe events hook
         * @summary Listen stripe events
         * @param {string} stripeSignature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeEvents(stripeSignature, options) {
            return localVarFp
                .stripeEvents(stripeSignature, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * HooksApi - object-oriented interface
 * @export
 * @class HooksApi
 * @extends {BaseAPI}
 */
export class HooksApi extends BaseAPI {
    /**
     * Listen email events hook
     * @summary Listen email events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HooksApi
     */
    emailEvents(options) {
        return HooksApiFp(this.configuration)
            .emailEvents(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Listen stripe events hook
     * @summary Listen stripe events
     * @param {string} stripeSignature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HooksApi
     */
    stripeEvents(stripeSignature, options) {
        return HooksApiFp(this.configuration)
            .stripeEvents(stripeSignature, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * IntegrationsApi - axios parameter creator
 * @export
 */
export const IntegrationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve integrations
         * @summary Retrieve integrations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveIntegrations: async (options = {}) => {
            const localVarPath = `/integrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IntegrationsApi - functional programming interface
 * @export
 */
export const IntegrationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = IntegrationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve integrations
         * @summary Retrieve integrations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveIntegrations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveIntegrations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * IntegrationsApi - factory interface
 * @export
 */
export const IntegrationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IntegrationsApiFp(configuration);
    return {
        /**
         * Retrieve integrations
         * @summary Retrieve integrations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveIntegrations(options) {
            return localVarFp
                .retrieveIntegrations(options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * IntegrationsApi - object-oriented interface
 * @export
 * @class IntegrationsApi
 * @extends {BaseAPI}
 */
export class IntegrationsApi extends BaseAPI {
    /**
     * Retrieve integrations
     * @summary Retrieve integrations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    retrieveIntegrations(options) {
        return IntegrationsApiFp(this.configuration)
            .retrieveIntegrations(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RuleApi - axios parameter creator
 * @export
 */
export const RuleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a list of your rules. The rules are returned sorted by __createdAt__ date by default.
         * @summary List all rules
         * @param {string} [name] Rule\&#39;s name
         * @param {string} [search] Search by name
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRules: async (name, search, size, orderBy, sortBy, page, options = {}) => {
            const localVarPath = `/v1/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RuleApi - functional programming interface
 * @export
 */
export const RuleApiFp = function (configuration) {
    const localVarAxiosParamCreator = RuleApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a list of your rules. The rules are returned sorted by __createdAt__ date by default.
         * @summary List all rules
         * @param {string} [name] Rule\&#39;s name
         * @param {string} [search] Search by name
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRules(name, search, size, orderBy, sortBy, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRules(name, search, size, orderBy, sortBy, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * RuleApi - factory interface
 * @export
 */
export const RuleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RuleApiFp(configuration);
    return {
        /**
         * Returns a list of your rules. The rules are returned sorted by __createdAt__ date by default.
         * @summary List all rules
         * @param {string} [name] Rule\&#39;s name
         * @param {string} [search] Search by name
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRules(name, search, size, orderBy, sortBy, page, options) {
            return localVarFp
                .retrieveRules(name, search, size, orderBy, sortBy, page, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * RuleApi - object-oriented interface
 * @export
 * @class RuleApi
 * @extends {BaseAPI}
 */
export class RuleApi extends BaseAPI {
    /**
     * Returns a list of your rules. The rules are returned sorted by __createdAt__ date by default.
     * @summary List all rules
     * @param {string} [name] Rule\&#39;s name
     * @param {string} [search] Search by name
     * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
     * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
     * @param {string} [sortBy] A list of properties that you can select to sort the list by.
     * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    retrieveRules(name, search, size, orderBy, sortBy, page, options) {
        return RuleApiFp(this.configuration)
            .retrieveRules(name, search, size, orderBy, sortBy, page, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TagsApi - axios parameter creator
 * @export
 */
export const TagsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Permanently deletes a tag. It cannot be undone. Also it will be immediately unattached from the __Document__ objects that have these tags attached.
         * @summary Delete a tag
         * @param {string} id The ID of the __Tag__ that is going to be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTag', 'id', id);
            const localVarPath = `/v1/tags/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'DELETE',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes a list of tags at once. It cannot be undone. Also it will be immediately unattached from the Document objects that have these tags attached.
         * @summary Delete tags
         * @param {Array<string>} ids An array of tag IDs that is going to be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTags: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteTags', 'ids', ids);
            const localVarPath = `/v1/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'DELETE',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Tag object.
         * @summary Retrieve a tag
         * @param {string} id An unique identifier for the object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveTag', 'id', id);
            const localVarPath = `/v1/tags/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of your tags. The tags are returned sorted by __createdAt__ date by default.
         * @summary List all tags
         * @param {string} [name] The tag name. The value must be a unique identifier.
         * @param {string} [color] The tag color. Often useful for displaying to users. The value must be a valid hexadecimal code.
         * @param {string} [search] Search tags by name
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTags: async (name, color, search, size, orderBy, sortBy, page, options = {}) => {
            const localVarPath = `/v1/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (color !== undefined) {
                localVarQueryParameter['color'] = color;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the specified document by setting the values of the parameters passed. The parameters that are not provided will be left unchanged.
         * @summary Update a tag
         * @param {string} id An unique identifier for the object.
         * @param {UpdateOrCreateTagInput} updateOrCreateTagInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag: async (id, updateOrCreateTagInput, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTag', 'id', id);
            // verify required parameter 'updateOrCreateTagInput' is not null or undefined
            assertParamExists('updateTag', 'updateOrCreateTagInput', updateOrCreateTagInput);
            const localVarPath = `/v1/tags/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'PUT',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrCreateTagInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a tag by setting the values of the parameters passed. The parameters that are not provided will not be saved.
         * @summary Create a tag
         * @param {UpdateOrCreateTagInput} updateOrCreateTagInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertTags: async (updateOrCreateTagInput, options = {}) => {
            // verify required parameter 'updateOrCreateTagInput' is not null or undefined
            assertParamExists('upsertTags', 'updateOrCreateTagInput', updateOrCreateTagInput);
            const localVarPath = `/v1/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrCreateTagInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration);
    return {
        /**
         * Permanently deletes a tag. It cannot be undone. Also it will be immediately unattached from the __Document__ objects that have these tags attached.
         * @summary Delete a tag
         * @param {string} id The ID of the __Tag__ that is going to be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTag(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Permanently deletes a list of tags at once. It cannot be undone. Also it will be immediately unattached from the Document objects that have these tags attached.
         * @summary Delete tags
         * @param {Array<string>} ids An array of tag IDs that is going to be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTags(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTags(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Tag object.
         * @summary Retrieve a tag
         * @param {string} id An unique identifier for the object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTag(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of your tags. The tags are returned sorted by __createdAt__ date by default.
         * @summary List all tags
         * @param {string} [name] The tag name. The value must be a unique identifier.
         * @param {string} [color] The tag color. Often useful for displaying to users. The value must be a valid hexadecimal code.
         * @param {string} [search] Search tags by name
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTags(name, color, search, size, orderBy, sortBy, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTags(name, color, search, size, orderBy, sortBy, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the specified document by setting the values of the parameters passed. The parameters that are not provided will be left unchanged.
         * @summary Update a tag
         * @param {string} id An unique identifier for the object.
         * @param {UpdateOrCreateTagInput} updateOrCreateTagInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTag(id, updateOrCreateTagInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTag(id, updateOrCreateTagInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a tag by setting the values of the parameters passed. The parameters that are not provided will not be saved.
         * @summary Create a tag
         * @param {UpdateOrCreateTagInput} updateOrCreateTagInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertTags(updateOrCreateTagInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertTags(updateOrCreateTagInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TagsApiFp(configuration);
    return {
        /**
         * Permanently deletes a tag. It cannot be undone. Also it will be immediately unattached from the __Document__ objects that have these tags attached.
         * @summary Delete a tag
         * @param {string} id The ID of the __Tag__ that is going to be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(id, options) {
            return localVarFp
                .deleteTag(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes a list of tags at once. It cannot be undone. Also it will be immediately unattached from the Document objects that have these tags attached.
         * @summary Delete tags
         * @param {Array<string>} ids An array of tag IDs that is going to be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTags(ids, options) {
            return localVarFp
                .deleteTags(ids, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Tag object.
         * @summary Retrieve a tag
         * @param {string} id An unique identifier for the object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTag(id, options) {
            return localVarFp
                .retrieveTag(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of your tags. The tags are returned sorted by __createdAt__ date by default.
         * @summary List all tags
         * @param {string} [name] The tag name. The value must be a unique identifier.
         * @param {string} [color] The tag color. Often useful for displaying to users. The value must be a valid hexadecimal code.
         * @param {string} [search] Search tags by name
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTags(name, color, search, size, orderBy, sortBy, page, options) {
            return localVarFp
                .retrieveTags(name, color, search, size, orderBy, sortBy, page, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Updates the specified document by setting the values of the parameters passed. The parameters that are not provided will be left unchanged.
         * @summary Update a tag
         * @param {string} id An unique identifier for the object.
         * @param {UpdateOrCreateTagInput} updateOrCreateTagInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(id, updateOrCreateTagInput, options) {
            return localVarFp
                .updateTag(id, updateOrCreateTagInput, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a tag by setting the values of the parameters passed. The parameters that are not provided will not be saved.
         * @summary Create a tag
         * @param {UpdateOrCreateTagInput} updateOrCreateTagInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertTags(updateOrCreateTagInput, options) {
            return localVarFp
                .upsertTags(updateOrCreateTagInput, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
export class TagsApi extends BaseAPI {
    /**
     * Permanently deletes a tag. It cannot be undone. Also it will be immediately unattached from the __Document__ objects that have these tags attached.
     * @summary Delete a tag
     * @param {string} id The ID of the __Tag__ that is going to be removed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    deleteTag(id, options) {
        return TagsApiFp(this.configuration)
            .deleteTag(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Permanently deletes a list of tags at once. It cannot be undone. Also it will be immediately unattached from the Document objects that have these tags attached.
     * @summary Delete tags
     * @param {Array<string>} ids An array of tag IDs that is going to be removed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    deleteTags(ids, options) {
        return TagsApiFp(this.configuration)
            .deleteTags(ids, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a Tag object.
     * @summary Retrieve a tag
     * @param {string} id An unique identifier for the object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    retrieveTag(id, options) {
        return TagsApiFp(this.configuration)
            .retrieveTag(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of your tags. The tags are returned sorted by __createdAt__ date by default.
     * @summary List all tags
     * @param {string} [name] The tag name. The value must be a unique identifier.
     * @param {string} [color] The tag color. Often useful for displaying to users. The value must be a valid hexadecimal code.
     * @param {string} [search] Search tags by name
     * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
     * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
     * @param {string} [sortBy] A list of properties that you can select to sort the list by.
     * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    retrieveTags(name, color, search, size, orderBy, sortBy, page, options) {
        return TagsApiFp(this.configuration)
            .retrieveTags(name, color, search, size, orderBy, sortBy, page, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the specified document by setting the values of the parameters passed. The parameters that are not provided will be left unchanged.
     * @summary Update a tag
     * @param {string} id An unique identifier for the object.
     * @param {UpdateOrCreateTagInput} updateOrCreateTagInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    updateTag(id, updateOrCreateTagInput, options) {
        return TagsApiFp(this.configuration)
            .updateTag(id, updateOrCreateTagInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a tag by setting the values of the parameters passed. The parameters that are not provided will not be saved.
     * @summary Create a tag
     * @param {UpdateOrCreateTagInput} updateOrCreateTagInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    upsertTags(updateOrCreateTagInput, options) {
        return TagsApiFp(this.configuration)
            .upsertTags(updateOrCreateTagInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TemplatesApi - axios parameter creator
 * @export
 */
export const TemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves a template object.
         * @summary Retrieve a template
         * @param {string} id An unique identifier for the object.
         * @param {Array<'account' | 'author' | 'fromDocument' | 'tags' | 'category'>} [expandable] Expanded params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplate: async (id, expandable, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveTemplate', 'id', id);
            const localVarPath = `/v1/templates/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (expandable) {
                localVarQueryParameter['expandable'] = expandable;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of your templates. The templates are returned sorted by createdAt date by default.
         * @summary List all templates
         * @param {string} [name] The document name without extension.
         * @param {string} [search] Search documents by name
         * @param {number} [folderId] The ID of the __Folder__ where the document is located on.
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplates: async (name, search, folderId, size, orderBy, sortBy, page, options = {}) => {
            const localVarPath = `/v1/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TemplatesApi - functional programming interface
 * @export
 */
export const TemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = TemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves a template object.
         * @summary Retrieve a template
         * @param {string} id An unique identifier for the object.
         * @param {Array<'account' | 'author' | 'fromDocument' | 'tags' | 'category'>} [expandable] Expanded params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTemplate(id, expandable, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTemplate(id, expandable, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of your templates. The templates are returned sorted by createdAt date by default.
         * @summary List all templates
         * @param {string} [name] The document name without extension.
         * @param {string} [search] Search documents by name
         * @param {number} [folderId] The ID of the __Folder__ where the document is located on.
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTemplates(name, search, folderId, size, orderBy, sortBy, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTemplates(name, search, folderId, size, orderBy, sortBy, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * TemplatesApi - factory interface
 * @export
 */
export const TemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TemplatesApiFp(configuration);
    return {
        /**
         * Retrieves a template object.
         * @summary Retrieve a template
         * @param {string} id An unique identifier for the object.
         * @param {Array<'account' | 'author' | 'fromDocument' | 'tags' | 'category'>} [expandable] Expanded params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplate(id, expandable, options) {
            return localVarFp
                .retrieveTemplate(id, expandable, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of your templates. The templates are returned sorted by createdAt date by default.
         * @summary List all templates
         * @param {string} [name] The document name without extension.
         * @param {string} [search] Search documents by name
         * @param {number} [folderId] The ID of the __Folder__ where the document is located on.
         * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
         * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
         * @param {string} [sortBy] A list of properties that you can select to sort the list by.
         * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplates(name, search, folderId, size, orderBy, sortBy, page, options) {
            return localVarFp
                .retrieveTemplates(name, search, folderId, size, orderBy, sortBy, page, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * TemplatesApi - object-oriented interface
 * @export
 * @class TemplatesApi
 * @extends {BaseAPI}
 */
export class TemplatesApi extends BaseAPI {
    /**
     * Retrieves a template object.
     * @summary Retrieve a template
     * @param {string} id An unique identifier for the object.
     * @param {Array<'account' | 'author' | 'fromDocument' | 'tags' | 'category'>} [expandable] Expanded params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    retrieveTemplate(id, expandable, options) {
        return TemplatesApiFp(this.configuration)
            .retrieveTemplate(id, expandable, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of your templates. The templates are returned sorted by createdAt date by default.
     * @summary List all templates
     * @param {string} [name] The document name without extension.
     * @param {string} [search] Search documents by name
     * @param {number} [folderId] The ID of the __Folder__ where the document is located on.
     * @param {number} [size] A limit on the number of objects to be returned. Limit can range between 1 and 100, and the default is __25__.
     * @param {'asc' | 'desc'} [orderBy] An order for displaying the results. The default is __desc__.
     * @param {string} [sortBy] A list of properties that you can select to sort the list by.
     * @param {number} [page] A cursor for __pagination__ across multiple pages of results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    retrieveTemplates(name, search, folderId, size, orderBy, sortBy, page, options) {
        return TemplatesApiFp(this.configuration)
            .retrieveTemplates(name, search, folderId, size, orderBy, sortBy, page, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Accept terms of service
         * @summary Accept tos
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTos: async (bounselAccount, options = {}) => {
            const localVarPath = `/vapp/users/tos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            if (bounselAccount != null) {
                localVarHeaderParameter['bounsel-account'] = String(bounselAccount);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a use
         * @summary Delete a user
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (bounselAccount, options = {}) => {
            const localVarPath = `/vapp/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'DELETE',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            if (bounselAccount != null) {
                localVarHeaderParameter['bounsel-account'] = String(bounselAccount);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logged in user
         * @summary Get me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me: async (options = {}) => {
            const localVarPath = `/vapp/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send verification email. Max 1 request per 15 seconds.
         * @summary Send verification email
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerifyEmail: async (email, options = {}) => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('sendVerifyEmail', 'email', email);
            const localVarPath = `/vapp/users/send-verify-email/{email}`.replace(`{${'email'}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set new user password
         * @summary Set password
         * @param {SetPasswordInput} setPasswordInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword: async (setPasswordInput, options = {}) => {
            // verify required parameter 'setPasswordInput' is not null or undefined
            assertParamExists('setPassword', 'setPasswordInput', setPasswordInput);
            const localVarPath = `/vapp/users/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update email from a user
         * @summary Update email
         * @param {UpdateEmailInput} updateEmailInput
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmail: async (updateEmailInput, bounselAccount, options = {}) => {
            // verify required parameter 'updateEmailInput' is not null or undefined
            assertParamExists('updateEmail', 'updateEmailInput', updateEmailInput);
            const localVarPath = `/vapp/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'PUT',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookie required
            if (bounselAccount != null) {
                localVarHeaderParameter['bounsel-account'] = String(bounselAccount);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify user email
         * @summary Verify user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUser: async (options = {}) => {
            const localVarPath = `/vapp/users/verify-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         * Accept terms of service
         * @summary Accept tos
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTos(bounselAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTos(bounselAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a use
         * @summary Delete a user
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(bounselAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(bounselAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Logged in user
         * @summary Get me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async me(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.me(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send verification email. Max 1 request per 15 seconds.
         * @summary Send verification email
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendVerifyEmail(email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendVerifyEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set new user password
         * @summary Set password
         * @param {SetPasswordInput} setPasswordInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPassword(setPasswordInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPassword(setPasswordInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update email from a user
         * @summary Update email
         * @param {UpdateEmailInput} updateEmailInput
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmail(updateEmailInput, bounselAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmail(updateEmailInput, bounselAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify user email
         * @summary Verify user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyUser(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         * Accept terms of service
         * @summary Accept tos
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTos(bounselAccount, options) {
            return localVarFp
                .acceptTos(bounselAccount, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a use
         * @summary Delete a user
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(bounselAccount, options) {
            return localVarFp
                .deleteUser(bounselAccount, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Logged in user
         * @summary Get me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me(options) {
            return localVarFp.me(options).then((request) => request(axios, basePath));
        },
        /**
         * Send verification email. Max 1 request per 15 seconds.
         * @summary Send verification email
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerifyEmail(email, options) {
            return localVarFp
                .sendVerifyEmail(email, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set new user password
         * @summary Set password
         * @param {SetPasswordInput} setPasswordInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(setPasswordInput, options) {
            return localVarFp
                .setPassword(setPasswordInput, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update email from a user
         * @summary Update email
         * @param {UpdateEmailInput} updateEmailInput
         * @param {string} [bounselAccount] Active account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmail(updateEmailInput, bounselAccount, options) {
            return localVarFp
                .updateEmail(updateEmailInput, bounselAccount, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Verify user email
         * @summary Verify user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUser(options) {
            return localVarFp
                .verifyUser(options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Accept terms of service
     * @summary Accept tos
     * @param {string} [bounselAccount] Active account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    acceptTos(bounselAccount, options) {
        return UsersApiFp(this.configuration)
            .acceptTos(bounselAccount, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a use
     * @summary Delete a user
     * @param {string} [bounselAccount] Active account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteUser(bounselAccount, options) {
        return UsersApiFp(this.configuration)
            .deleteUser(bounselAccount, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Logged in user
     * @summary Get me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    me(options) {
        return UsersApiFp(this.configuration)
            .me(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Send verification email. Max 1 request per 15 seconds.
     * @summary Send verification email
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    sendVerifyEmail(email, options) {
        return UsersApiFp(this.configuration)
            .sendVerifyEmail(email, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set new user password
     * @summary Set password
     * @param {SetPasswordInput} setPasswordInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setPassword(setPasswordInput, options) {
        return UsersApiFp(this.configuration)
            .setPassword(setPasswordInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update email from a user
     * @summary Update email
     * @param {UpdateEmailInput} updateEmailInput
     * @param {string} [bounselAccount] Active account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    updateEmail(updateEmailInput, bounselAccount, options) {
        return UsersApiFp(this.configuration)
            .updateEmail(updateEmailInput, bounselAccount, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Verify user email
     * @summary Verify user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    verifyUser(options) {
        return UsersApiFp(this.configuration)
            .verifyUser(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WebhookApi - axios parameter creator
 * @export
 */
export const WebhookApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a list of your Events. The events are returned alphabetically.
         * @summary List all events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveEvents: async (options = {}) => {
            const localVarPath = `/v1/webhooks/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a __Webhook__ subscription by setting the values of the parameters passed. Any parameters that are not provided will not be saved.
         * @summary Create a webhook subscription
         * @param {UpdateOrCreateWebhookInput} updateOrCreateWebhookInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeWebhook: async (updateOrCreateWebhookInput, options = {}) => {
            // verify required parameter 'updateOrCreateWebhookInput' is not null or undefined
            assertParamExists('subscribeWebhook', 'updateOrCreateWebhookInput', updateOrCreateWebhookInput);
            const localVarPath = `/v1/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'POST',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrCreateWebhookInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes a webhook subscription. It cannot be undone.
         * @summary Delete a webhook subscription
         * @param {string} id The ID of the __Webhook__ subscription that is going to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWebhook: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unsubscribeWebhook', 'id', id);
            const localVarPath = `/v1/webhooks/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'DELETE',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WebhookApi - functional programming interface
 * @export
 */
export const WebhookApiFp = function (configuration) {
    const localVarAxiosParamCreator = WebhookApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a list of your Events. The events are returned alphabetically.
         * @summary List all events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveEvents(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveEvents(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a __Webhook__ subscription by setting the values of the parameters passed. Any parameters that are not provided will not be saved.
         * @summary Create a webhook subscription
         * @param {UpdateOrCreateWebhookInput} updateOrCreateWebhookInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeWebhook(updateOrCreateWebhookInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeWebhook(updateOrCreateWebhookInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Permanently deletes a webhook subscription. It cannot be undone.
         * @summary Delete a webhook subscription
         * @param {string} id The ID of the __Webhook__ subscription that is going to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeWebhook(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeWebhook(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * WebhookApi - factory interface
 * @export
 */
export const WebhookApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WebhookApiFp(configuration);
    return {
        /**
         * Returns a list of your Events. The events are returned alphabetically.
         * @summary List all events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveEvents(options) {
            return localVarFp
                .retrieveEvents(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a __Webhook__ subscription by setting the values of the parameters passed. Any parameters that are not provided will not be saved.
         * @summary Create a webhook subscription
         * @param {UpdateOrCreateWebhookInput} updateOrCreateWebhookInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeWebhook(updateOrCreateWebhookInput, options) {
            return localVarFp
                .subscribeWebhook(updateOrCreateWebhookInput, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes a webhook subscription. It cannot be undone.
         * @summary Delete a webhook subscription
         * @param {string} id The ID of the __Webhook__ subscription that is going to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWebhook(id, options) {
            return localVarFp
                .unsubscribeWebhook(id, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * WebhookApi - object-oriented interface
 * @export
 * @class WebhookApi
 * @extends {BaseAPI}
 */
export class WebhookApi extends BaseAPI {
    /**
     * Returns a list of your Events. The events are returned alphabetically.
     * @summary List all events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    retrieveEvents(options) {
        return WebhookApiFp(this.configuration)
            .retrieveEvents(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a __Webhook__ subscription by setting the values of the parameters passed. Any parameters that are not provided will not be saved.
     * @summary Create a webhook subscription
     * @param {UpdateOrCreateWebhookInput} updateOrCreateWebhookInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    subscribeWebhook(updateOrCreateWebhookInput, options) {
        return WebhookApiFp(this.configuration)
            .subscribeWebhook(updateOrCreateWebhookInput, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Permanently deletes a webhook subscription. It cannot be undone.
     * @summary Delete a webhook subscription
     * @param {string} id The ID of the __Webhook__ subscription that is going to remove.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    unsubscribeWebhook(id, options) {
        return WebhookApiFp(this.configuration)
            .unsubscribeWebhook(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
